import { esClient as api } from '../app/store/empty-api'

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createOrgAiCampaign: build.mutation<CreateOrgAiCampaignApiResponse, CreateOrgAiCampaignApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/aicamp`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getAirtimePricing: build.query<GetAirtimePricingApiResponse, GetAirtimePricingApiArg>({
      query: (queryArg) => ({
        url: `/airtime/pricing`,
        params: {
          country: queryArg.country,
        },
      }),
    }),
    authSignup: build.mutation<AuthSignupApiResponse, AuthSignupApiArg>({
      query: (queryArg) => ({
        url: `/v1/auth/signup`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    authSignupEmail: build.mutation<AuthSignupEmailApiResponse, AuthSignupEmailApiArg>({
      query: (queryArg) => ({
        url: `/v1/auth/signupemail`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    authEmailcheck: build.query<AuthEmailcheckApiResponse, AuthEmailcheckApiArg>({
      query: (queryArg) => ({
        url: `/v1/auth/emailcheck`,
        params: {
          email: queryArg.email,
        },
      }),
    }),
    authSignin: build.mutation<AuthSigninApiResponse, AuthSigninApiArg>({
      query: (queryArg) => ({
        url: `/v1/auth/signin`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    authTotp: build.mutation<AuthTotpApiResponse, AuthTotpApiArg>({
      query: (queryArg) => ({
        url: `/v1/auth/totp`,
        method: 'POST',
        body: queryArg.body,
        headers: {
          Authorization: queryArg.authorization,
        },
      }),
    }),
    authPasswordReset: build.mutation<AuthPasswordResetApiResponse, AuthPasswordResetApiArg>({
      query: (queryArg) => ({
        url: `/v1/auth/passwordreset`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    authPasswordResetChange: build.mutation<AuthPasswordResetChangeApiResponse, AuthPasswordResetChangeApiArg>({
      query: (queryArg) => ({
        url: `/v1/auth/passwordresetchange`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    signPaths: build.mutation<SignPathsApiResponse, SignPathsApiArg>({
      query: (queryArg) => ({
        url: `/v1/sign`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getOrgBalance: build.query<GetOrgBalanceApiResponse, GetOrgBalanceApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/balance.json`,
      }),
    }),
    updateOrgBalance: build.mutation<UpdateOrgBalanceApiResponse, UpdateOrgBalanceApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/balance.json`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getOrgBilling: build.query<GetOrgBillingApiResponse, GetOrgBillingApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/billing.json`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
        },
      }),
    }),
    transferOrgFunds: build.mutation<TransferOrgFundsApiResponse, TransferOrgFundsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/fundstransfer.json`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    listOrgRecordings: build.query<ListOrgRecordingsApiResponse, ListOrgRecordingsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/recordings/`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          campid: queryArg.campid,
          userid: queryArg.userid,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
        },
      }),
    }),
    downloadOrgRecordings: build.mutation<DownloadOrgRecordingsApiResponse, DownloadOrgRecordingsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/recordings/download`,
        method: 'POST',
        params: {
          page: queryArg.page,
          size: queryArg.size,
          campid: queryArg.campid,
          userid: queryArg.userid,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
        },
      }),
    }),
    getOrgRecording: build.query<GetOrgRecordingApiResponse, GetOrgRecordingApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/recordings/${queryArg.recordingId}/`,
      }),
    }),
    downloadOrgRecording: build.query<DownloadOrgRecordingApiResponse, DownloadOrgRecordingApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/recordings/${queryArg.recordingId}/download`,
      }),
    }),
    listCampaigns: build.query<ListCampaignsApiResponse, ListCampaignsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          published: queryArg.published,
          launched: queryArg.launched,
          open: queryArg.open,
          aborted: queryArg.aborted,
          archived: queryArg.archived,
          templates: queryArg.templates,
          search: queryArg.search,
        },
      }),
    }),
    createCampaign: build.mutation<CreateCampaignApiResponse, CreateCampaignApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getCampaign: build.query<GetCampaignApiResponse, GetCampaignApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/`,
      }),
    }),
    updateCampaign: build.mutation<UpdateCampaignApiResponse, UpdateCampaignApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    deleteCampaign: build.mutation<DeleteCampaignApiResponse, DeleteCampaignApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/`,
        method: 'DELETE',
      }),
    }),
    subscribeContact: build.mutation<SubscribeContactApiResponse, SubscribeContactApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/subscribe`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    subscribeContacts: build.mutation<SubscribeContactsApiResponse, SubscribeContactsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/subscribecontacts`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    unsubscribeContact: build.mutation<UnsubscribeContactApiResponse, UnsubscribeContactApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/unsubscribe`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    unsubscribeContacts: build.mutation<UnsubscribeContactsApiResponse, UnsubscribeContactsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/unsubscribecontacts`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    setCampaignOpen: build.mutation<SetCampaignOpenApiResponse, SetCampaignOpenApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/open`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    setCampaignArchived: build.mutation<SetCampaignArchivedApiResponse, SetCampaignArchivedApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/archived`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    abortCampaign: build.mutation<AbortCampaignApiResponse, AbortCampaignApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/abort`,
        method: 'POST',
      }),
    }),
    copyCampaign: build.mutation<CopyCampaignApiResponse, CopyCampaignApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/copy`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    reopenContacts: build.mutation<ReopenContactsApiResponse, ReopenContactsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/reopencontacts`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    setCampaignPublished: build.mutation<SetCampaignPublishedApiResponse, SetCampaignPublishedApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/published`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getCampaignSummary: build.query<GetCampaignSummaryApiResponse, GetCampaignSummaryApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/summary`,
      }),
    }),
    exportCampaignReport: build.query<ExportCampaignReportApiResponse, ExportCampaignReportApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/engagements/${queryArg.campaignId}/exportreport`,
        params: {
          tz: queryArg.tz,
          labels: queryArg.labels,
          columns: queryArg.columns,
          reportfields: queryArg.reportfields,
        },
      }),
    }),
    listCampaignSubscriptions: build.query<ListCampaignSubscriptionsApiResponse, ListCampaignSubscriptionsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/campaigns/${queryArg.campaignId}/subscriptions/`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          done: queryArg.done,
          error: queryArg.error,
          search: queryArg.search,
        },
      }),
    }),
    getCampaignSubscription: build.query<GetCampaignSubscriptionApiResponse, GetCampaignSubscriptionApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/campaigns/${queryArg.campaignId}/subscriptions/${queryArg.subId}/`,
      }),
    }),
    getOrgAutodelete: build.query<GetOrgAutodeleteApiResponse, GetOrgAutodeleteApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/autodelete`,
        params: {
          days: queryArg.days,
        },
      }),
    }),
    listContacts: build.query<ListContactsApiResponse, ListContactsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/contacts/`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          search: queryArg.search,
          phonenumber: queryArg.phonenumber,
          region: queryArg.region,
          groupid: queryArg.groupid,
          noautodelete: queryArg.noautodelete,
          whatsappready: queryArg.whatsappready,
          conditions: queryArg.conditions,
          subscriptionstatus: queryArg.subscriptionstatus,
          subscriptionfilter: queryArg.subscriptionfilter,
        },
      }),
    }),
    createContact: build.mutation<CreateContactApiResponse, CreateContactApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/contacts/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getContact: build.query<GetContactApiResponse, GetContactApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/contacts/${queryArg.contactId}/`,
        params: {
          subscriptionstatus: queryArg.subscriptionstatus,
        },
      }),
    }),
    updateContact: build.mutation<UpdateContactApiResponse, UpdateContactApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/contacts/${queryArg.contactId}/`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    deleteContact: build.mutation<DeleteContactApiResponse, DeleteContactApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/contacts/${queryArg.contactId}/`,
        method: 'DELETE',
      }),
    }),
    getOrgCustomfields: build.query<GetOrgCustomfieldsApiResponse, GetOrgCustomfieldsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/customfields/`,
      }),
    }),
    createOrgCustomfield: build.mutation<CreateOrgCustomfieldApiResponse, CreateOrgCustomfieldApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/customfields/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    updateOrgCustomfield: build.mutation<UpdateOrgCustomfieldApiResponse, UpdateOrgCustomfieldApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/customfields/${queryArg.customfieldId}/`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    deleteOrgCustomfield: build.mutation<DeleteOrgCustomfieldApiResponse, DeleteOrgCustomfieldApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/customfields/${queryArg.customfieldId}/`,
        method: 'DELETE',
      }),
    }),
    cxRequest: build.mutation<CxRequestApiResponse, CxRequestApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/cx`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    listDatatables: build.query<ListDatatablesApiResponse, ListDatatablesApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/datatables/`,
      }),
    }),
    getDatatable: build.query<GetDatatableApiResponse, GetDatatableApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/datatables/${queryArg.datatableId}/`,
      }),
    }),
    popDatatable: build.query<PopDatatableApiResponse, PopDatatableApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/datatables/${queryArg.datatableId}/pop`,
      }),
    }),
    rowsDatatable: build.query<RowsDatatableApiResponse, RowsDatatableApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/datatables/${queryArg.datatableId}/rows/`,
        params: {
          popped: queryArg.popped,
        },
      }),
    }),
    rowDatatable: build.query<RowDatatableApiResponse, RowDatatableApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/datatables/${queryArg.datatableId}/rows/${queryArg.rowId}/`,
      }),
    }),
    putrowDatatable: build.mutation<PutrowDatatableApiResponse, PutrowDatatableApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/datatables/${queryArg.datatableId}/rows/${queryArg.rowId}/`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    getOrgDids: build.query<GetOrgDidsApiResponse, GetOrgDidsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/phonenumbers/`,
      }),
    }),
    getOrgDid: build.query<GetOrgDidApiResponse, GetOrgDidApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/phonenumbers/${queryArg.didId}/`,
      }),
    }),
    postOrgDid: build.mutation<PostOrgDidApiResponse, PostOrgDidApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/phonenumbers/${queryArg.didId}/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    postDidRegisterWhatsApp: build.mutation<PostDidRegisterWhatsAppApiResponse, PostDidRegisterWhatsAppApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/phonenumbers/${queryArg.didId}/registerwhatsapp`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    createOrgDidHook: build.mutation<CreateOrgDidHookApiResponse, CreateOrgDidHookApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/phonenumbers/${queryArg.didId}/hooks/`,
        method: 'POST',
        body: queryArg.schemaInboundHookPayload,
      }),
    }),
    updateOrgDidHook: build.mutation<UpdateOrgDidHookApiResponse, UpdateOrgDidHookApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/phonenumbers/${queryArg.didId}/hooks/${queryArg.hookId}/`,
        method: 'POST',
        body: queryArg.schemaInboundHook,
      }),
    }),
    deleteOrgDidHook: build.mutation<DeleteOrgDidHookApiResponse, DeleteOrgDidHookApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/phonenumbers/${queryArg.didId}/hooks/${queryArg.hookId}/`,
        method: 'DELETE',
      }),
    }),
    createOrgDidCallHook: build.mutation<CreateOrgDidCallHookApiResponse, CreateOrgDidCallHookApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/phonenumbers/${queryArg.didId}/callhooks/`,
        method: 'POST',
        body: queryArg.schemaInboundHookPayload,
      }),
    }),
    updateOrgDidCallHook: build.mutation<UpdateOrgDidCallHookApiResponse, UpdateOrgDidCallHookApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/phonenumbers/${queryArg.didId}/callhooks/${queryArg.hookId}/`,
        method: 'POST',
        body: queryArg.schemaInboundHook,
      }),
    }),
    deleteOrgDidCallHook: build.mutation<DeleteOrgDidCallHookApiResponse, DeleteOrgDidCallHookApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/phonenumbers/${queryArg.didId}/callhooks/${queryArg.hookId}/`,
        method: 'DELETE',
      }),
    }),
    createOrgDidWaHook: build.mutation<CreateOrgDidWaHookApiResponse, CreateOrgDidWaHookApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/phonenumbers/${queryArg.didId}/wahooks/`,
        method: 'POST',
        body: queryArg.schemaInboundHookPayload,
      }),
    }),
    updateOrgDidWaHook: build.mutation<UpdateOrgDidWaHookApiResponse, UpdateOrgDidWaHookApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/phonenumbers/${queryArg.didId}/wahooks/${queryArg.hookId}/`,
        method: 'POST',
        body: queryArg.schemaInboundHook,
      }),
    }),
    deleteOrgDidWaHook: build.mutation<DeleteOrgDidWaHookApiResponse, DeleteOrgDidWaHookApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/phonenumbers/${queryArg.didId}/wahooks/${queryArg.hookId}/`,
        method: 'DELETE',
      }),
    }),
    getExportsList: build.query<GetExportsListApiResponse, GetExportsListApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/exports/`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          functions: queryArg.functions,
          exfunctions: queryArg.exfunctions,
        },
      }),
    }),
    getExport: build.query<GetExportApiResponse, GetExportApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/exports/${queryArg.exportId}/`,
      }),
    }),
    deleteExport: build.mutation<DeleteExportApiResponse, DeleteExportApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/exports/${queryArg.exportId}/`,
        method: 'DELETE',
      }),
    }),
    getExportsFile: build.query<GetExportsFileApiResponse, GetExportsFileApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/exports/${queryArg.exportId}/${queryArg.filename}`,
      }),
    }),
    getFileList: build.query<GetFileListApiResponse, GetFileListApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/files/`,
        params: {
          category: queryArg.category,
        },
      }),
    }),
    uploadFile: build.mutation<UploadFileApiResponse, UploadFileApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/files/`,
        method: 'POST',
        body: queryArg.body,
        params: {
          category: queryArg.category,
          filter: queryArg.filter,
          video: queryArg.video,
        },
      }),
    }),
    downloadFile: build.query<DownloadFileApiResponse, DownloadFileApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/files/${queryArg.filename}`,
      }),
    }),
    updateFile: build.mutation<UpdateFileApiResponse, UpdateFileApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/files/${queryArg.filename}`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    deleteFile: build.mutation<DeleteFileApiResponse, DeleteFileApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/files/${queryArg.filename}`,
        method: 'DELETE',
      }),
    }),
    getOrgGroupsList: build.query<GetOrgGroupsListApiResponse, GetOrgGroupsListApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/groups/`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          sortBy: queryArg.sortBy,
          direction: queryArg.direction,
          type: queryArg.type,
          search: queryArg.search,
        },
      }),
    }),
    createOrgGroup: build.mutation<CreateOrgGroupApiResponse, CreateOrgGroupApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/groups/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getOrgGroup: build.query<GetOrgGroupApiResponse, GetOrgGroupApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/groups/${queryArg.groupId}/`,
      }),
    }),
    updateOrgGroup: build.mutation<UpdateOrgGroupApiResponse, UpdateOrgGroupApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/groups/${queryArg.groupId}/`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    deleteOrgGroup: build.mutation<DeleteOrgGroupApiResponse, DeleteOrgGroupApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/groups/${queryArg.groupId}/`,
        method: 'DELETE',
      }),
    }),
    addOrgGroupsContacts: build.mutation<AddOrgGroupsContactsApiResponse, AddOrgGroupsContactsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/groups/contacts`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    deleteOrgGroupContacts: build.mutation<DeleteOrgGroupContactsApiResponse, DeleteOrgGroupContactsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/groups/${queryArg.groupId}/contacts`,
        method: 'DELETE',
        body: queryArg.body,
      }),
    }),
    inviteCheck: build.query<InviteCheckApiResponse, InviteCheckApiArg>({
      query: (queryArg) => ({
        url: `/invites/check.json`,
        params: {
          invtoken: queryArg.invtoken,
        },
      }),
    }),
    inviteAccept: build.mutation<InviteAcceptApiResponse, InviteAcceptApiArg>({
      query: (queryArg) => ({
        url: `/invites/accept.json`,
        method: 'POST',
        params: {
          invtoken: queryArg.invtoken,
        },
      }),
    }),
    inviteSignupAccept: build.mutation<InviteSignupAcceptApiResponse, InviteSignupAcceptApiArg>({
      query: (queryArg) => ({
        url: `/invites/signupaccept.json`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getOrgInvitesList: build.query<GetOrgInvitesListApiResponse, GetOrgInvitesListApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/invites/`,
      }),
    }),
    createOrgInvite: build.mutation<CreateOrgInviteApiResponse, CreateOrgInviteApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/invites/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    deleteOrgInvite: build.mutation<DeleteOrgInviteApiResponse, DeleteOrgInviteApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/invites/${queryArg.inviteId}/`,
        method: 'DELETE',
      }),
    }),
    createOrgBankTransferPdf: build.mutation<CreateOrgBankTransferPdfApiResponse, CreateOrgBankTransferPdfApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/banktransfer/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getOrgInvoiceList: build.query<GetOrgInvoiceListApiResponse, GetOrgInvoiceListApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/invoices/`,
      }),
    }),
    createOrganization: build.mutation<CreateOrganizationApiResponse, CreateOrganizationApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getOrganization: build.query<GetOrganizationApiResponse, GetOrganizationApiArg>({
      query: (queryArg) => ({ url: `/v1/organizations/${queryArg.orgId}/` }),
    }),
    updateOrganization: build.mutation<UpdateOrganizationApiResponse, UpdateOrganizationApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getOrgPlan: build.query<GetOrgPlanApiResponse, GetOrgPlanApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/plan.json`,
      }),
    }),
    updateOrgPlan: build.mutation<UpdateOrgPlanApiResponse, UpdateOrgPlanApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/plan.json`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    cancelOrgPlan: build.mutation<CancelOrgPlanApiResponse, CancelOrgPlanApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/plan.json`,
        method: 'DELETE',
      }),
    }),
    getOrgPaymentsCreditCards: build.query<GetOrgPaymentsCreditCardsApiResponse, GetOrgPaymentsCreditCardsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/payments/creditcards/`,
      }),
    }),
    postOrgPaymentsCreditCards: build.mutation<PostOrgPaymentsCreditCardsApiResponse, PostOrgPaymentsCreditCardsApiArg>(
      {
        query: (queryArg) => ({
          url: `/v1/organizations/${queryArg.orgId}/payments/creditcards/`,
          method: 'POST',
          body: queryArg.body,
        }),
      },
    ),
    deleteOrgPaymentsCreditCard: build.mutation<
      DeleteOrgPaymentsCreditCardApiResponse,
      DeleteOrgPaymentsCreditCardApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/payments/creditcards/${queryArg.ccid}/`,
        method: 'DELETE',
      }),
    }),
    postOrgPaymentsCreditCardCharge: build.mutation<
      PostOrgPaymentsCreditCardChargeApiResponse,
      PostOrgPaymentsCreditCardChargeApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/payments/creditcards/${queryArg.ccid}/charge`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getOrgPhonenumber: build.query<GetOrgPhonenumberApiResponse, GetOrgPhonenumberApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/phonenumber`,
        params: {
          phonenumber: queryArg.phonenumber,
          region: queryArg.region,
        },
      }),
    }),
    getBlockList: build.query<GetBlockListApiResponse, GetBlockListApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/blocks/`,
      }),
    }),
    createBlock: build.mutation<CreateBlockApiResponse, CreateBlockApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/blocks/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getBlock: build.query<GetBlockApiResponse, GetBlockApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/blocks/${queryArg.blockId}/`,
      }),
    }),
    deleteBlock: build.mutation<DeleteBlockApiResponse, DeleteBlockApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/blocks/${queryArg.blockId}/`,
        method: 'DELETE',
      }),
    }),
    getOrgPurchaseList: build.query<GetOrgPurchaseListApiResponse, GetOrgPurchaseListApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/purchases.json`,
      }),
    }),
    createOrgReport: build.mutation<CreateOrgReportApiResponse, CreateOrgReportApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/report`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getOrgSenderIds: build.query<GetOrgSenderIdsApiResponse, GetOrgSenderIdsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/senderids/`,
      }),
    }),
    sendOrgSmsContacts: build.mutation<SendOrgSmsContactsApiResponse, SendOrgSmsContactsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/sms/contacts`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    sendSmsContact: build.mutation<SendSmsContactApiResponse, SendSmsContactApiArg>({
      query: (queryArg) => ({
        url: `/v1/sms/contact`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    sendSmsPhonenumber: build.mutation<SendSmsPhonenumberApiResponse, SendSmsPhonenumberApiArg>({
      query: (queryArg) => ({
        url: `/v1/sms/phonenumber`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    sendWhatsAppContact: build.mutation<SendWhatsAppContactApiResponse, SendWhatsAppContactApiArg>({
      query: (queryArg) => ({
        url: `/v1/whatsapp/contact`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getSmsList: build.query<GetSmsListApiResponse, GetSmsListApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/messages/`,
        params: {
          after: queryArg.after,
          limit: queryArg.limit,
          page: queryArg.page,
          size: queryArg.size,
          dir: queryArg.dir,
          failed: queryArg.failed,
          search: queryArg.search,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
        },
      }),
    }),
    getSms: build.query<GetSmsApiResponse, GetSmsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/messages/${queryArg.messageId}/`,
      }),
    }),
    getSnippetList: build.query<GetSnippetListApiResponse, GetSnippetListApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/snippets/`,
        params: {
          all: queryArg.all,
          category: queryArg.category,
        },
      }),
    }),
    createSnippet: build.mutation<CreateSnippetApiResponse, CreateSnippetApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/snippets/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getSnippet: build.query<GetSnippetApiResponse, GetSnippetApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/snippets/${queryArg.snippetId}`,
      }),
    }),
    updateSnippet: build.mutation<UpdateSnippetApiResponse, UpdateSnippetApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/snippets/${queryArg.snippetId}`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    deleteSnippet: build.mutation<DeleteSnippetApiResponse, DeleteSnippetApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/snippets/${queryArg.snippetId}`,
        method: 'DELETE',
      }),
    }),
    updateSubscriptions: build.mutation<UpdateSubscriptionsApiResponse, UpdateSubscriptionsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/subs/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    updateSubscription: build.mutation<UpdateSubscriptionApiResponse, UpdateSubscriptionApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/subs/${queryArg.subId}/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    subsReopen: build.mutation<SubsReopenApiResponse, SubsReopenApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/subs/${queryArg.subId}/reopen`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    createSpeechPreview: build.mutation<CreateSpeechPreviewApiResponse, CreateSpeechPreviewApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/say`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    sendOrgTopup: build.mutation<SendOrgTopupApiResponse, SendOrgTopupApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/topup/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getOrgTopupsList: build.query<GetOrgTopupsListApiResponse, GetOrgTopupsListApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/topups/`,
        params: {
          after: queryArg.after,
          limit: queryArg.limit,
          page: queryArg.page,
          size: queryArg.size,
          failed: queryArg.failed,
          search: queryArg.search,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
        },
      }),
    }),
    getOrgTopups: build.query<GetOrgTopupsApiResponse, GetOrgTopupsApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/topups/${queryArg.topupId}/`,
      }),
    }),
    listOrgQuotas: build.query<ListOrgQuotasApiResponse, ListOrgQuotasApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/quotas/`,
        params: {
          campid: queryArg.campid,
        },
      }),
    }),
    createOrgQuota: build.mutation<CreateOrgQuotaApiResponse, CreateOrgQuotaApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/quotas/`,
        method: 'POST',
        body: queryArg.schemaQuotaAdd,
      }),
    }),
    getOrgQuota: build.query<GetOrgQuotaApiResponse, GetOrgQuotaApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/quotas/${queryArg.quotaId}/`,
      }),
    }),
    updateOrgQuota: build.mutation<UpdateOrgQuotaApiResponse, UpdateOrgQuotaApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/quotas/${queryArg.quotaId}/`,
        method: 'POST',
        body: queryArg.schemaQuotaEdit,
      }),
    }),
    deleteOrgQuota: build.mutation<DeleteOrgQuotaApiResponse, DeleteOrgQuotaApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/quotas/${queryArg.quotaId}/`,
        method: 'DELETE',
      }),
    }),
    transcribeFile: build.mutation<TranscribeFileApiResponse, TranscribeFileApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/transcribe`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getUser: build.query<GetUserApiResponse, GetUserApiArg>({
      query: () => ({ url: `/v1/user/` }),
    }),
    saveUser: build.mutation<SaveUserApiResponse, SaveUserApiArg>({
      query: (queryArg) => ({
        url: `/v1/user/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    userFeedback: build.mutation<UserFeedbackApiResponse, UserFeedbackApiArg>({
      query: (queryArg) => ({
        url: `/v1/user/feedback`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getUserTotp: build.query<GetUserTotpApiResponse, GetUserTotpApiArg>({
      query: () => ({ url: `/v1/user/totp.json` }),
    }),
    setUserTotp: build.mutation<SetUserTotpApiResponse, SetUserTotpApiArg>({
      query: (queryArg) => ({
        url: `/v1/user/totp.json`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    disableUserTotp: build.mutation<DisableUserTotpApiResponse, DisableUserTotpApiArg>({
      query: () => ({ url: `/v1/user/totp.json`, method: 'DELETE' }),
    }),
    getUserRecoveryCodes: build.query<GetUserRecoveryCodesApiResponse, GetUserRecoveryCodesApiArg>({
      query: () => ({ url: `/v1/user/recoverycodes.json` }),
    }),
    newUserRecoveryCodes: build.mutation<NewUserRecoveryCodesApiResponse, NewUserRecoveryCodesApiArg>({
      query: () => ({ url: `/v1/user/recoverycodes.json`, method: 'POST' }),
    }),
    listUserAuthTokens: build.query<ListUserAuthTokensApiResponse, ListUserAuthTokensApiArg>({
      query: () => ({ url: `/v1/user/authtokens/` }),
    }),
    createUserAuthToken: build.mutation<CreateUserAuthTokenApiResponse, CreateUserAuthTokenApiArg>({
      query: () => ({ url: `/v1/user/authtokens/`, method: 'POST' }),
    }),
    getUserAuthToken: build.query<GetUserAuthTokenApiResponse, GetUserAuthTokenApiArg>({
      query: (queryArg) => ({
        url: `/v1/user/authtokens/${queryArg.tokenId}/`,
      }),
    }),
    updateUserAuthToken: build.mutation<UpdateUserAuthTokenApiResponse, UpdateUserAuthTokenApiArg>({
      query: (queryArg) => ({
        url: `/v1/user/authtokens/${queryArg.tokenId}/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    deleteUserAuthToken: build.mutation<DeleteUserAuthTokenApiResponse, DeleteUserAuthTokenApiArg>({
      query: (queryArg) => ({
        url: `/v1/user/authtokens/${queryArg.tokenId}/`,
        method: 'DELETE',
      }),
    }),
    getOrgUserList: build.query<GetOrgUserListApiResponse, GetOrgUserListApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/users/`,
      }),
    }),
    getOrgUser: build.query<GetOrgUserApiResponse, GetOrgUserApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/users/${queryArg.userId}/`,
      }),
    }),
    updateOrgUser: build.mutation<UpdateOrgUserApiResponse, UpdateOrgUserApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/users/${queryArg.userId}/`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    deleteOrgUser: build.mutation<DeleteOrgUserApiResponse, DeleteOrgUserApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/users/${queryArg.userId}/`,
        method: 'DELETE',
      }),
    }),
    getWhatsAppList: build.query<GetWhatsAppListApiResponse, GetWhatsAppListApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/whatsapp/`,
        params: {
          after: queryArg.after,
          limit: queryArg.limit,
          page: queryArg.page,
          size: queryArg.size,
          dir: queryArg.dir,
          failed: queryArg.failed,
          search: queryArg.search,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
        },
      }),
    }),
    getWhatsApp: build.query<GetWhatsAppApiResponse, GetWhatsAppApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/whatsapp/${queryArg.messageId}/`,
        params: {
          sign: queryArg.sign,
        },
      }),
    }),
    exportWhatsApp: build.query<ExportWhatsAppApiResponse, ExportWhatsAppApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/whatsapp/export.xlsx`,
        params: {
          tz: queryArg.tz,
          dir: queryArg.dir,
          failed: queryArg.failed,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
        },
      }),
    }),
    getOrgWaTemplatesList: build.query<GetOrgWaTemplatesListApiResponse, GetOrgWaTemplatesListApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/watemplates/`,
        params: {
          register: queryArg.register,
          approved: queryArg.approved,
        },
      }),
    }),
    getOrgWaTemplatesGet: build.query<GetOrgWaTemplatesGetApiResponse, GetOrgWaTemplatesGetApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/watemplates/${queryArg.id}/`,
      }),
    }),
    getOrgWaTemplatesRefresh: build.mutation<GetOrgWaTemplatesRefreshApiResponse, GetOrgWaTemplatesRefreshApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/watemplates/${queryArg.id}/refresh`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getOrgWaTemplatesRegister: build.mutation<GetOrgWaTemplatesRegisterApiResponse, GetOrgWaTemplatesRegisterApiArg>({
      query: (queryArg) => ({
        url: `/v1/organizations/${queryArg.orgId}/watemplates/${queryArg.id}/register`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
  }),
  overrideExisting: false,
})

export { injectedRtkApi as esApi }
export type CreateOrgAiCampaignApiResponse =
  /** status 200 OK. The AI campaign request has been successfully queued for processing. Use the returned export ID to monitor the progress of the campaign creation. */ {
    /** The ID of the export/report job that will process this AI campaign. Use this ID to check the status and retrieve results via the exports endpoints. */
    exportId: number
  }
export type CreateOrgAiCampaignApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** The file to be processed by the AI system. The filename is important as it is used by the AI processing engine. */
    file: Blob
    /** The type of AI campaign to create. Currently only "ivr" (Interactive Voice Response) is supported. */
    type: 'ivr'
  }
}
export type GetAirtimePricingApiResponse = /** status 200 Airtime pricing for the country */ SchemaPricing
export type GetAirtimePricingApiArg = {
  /** A two letter country code (ISO 3166-1 alpha-2), e.g. DE, TH */
  country: string
}
export type AuthSignupApiResponse = /** status 200 Signup successful */ {
  /** User ID. */
  id: number
  /** Access token for the new session. */
  access: string
  /** The access token is valid until this time. */
  validUntil: string
  activeOrganization: {
    /** ID of the active organization. */
    id: number
    /** Name of the active organization. */
    name: string
  }
}
export type AuthSignupApiArg = {
  body: {
    /** User's email address. */
    email: string
    /** User's password. */
    password: string
    /** User's first name. */
    first_name: string
    /** User's last name. */
    last_name: string
    /** User's phone number. */
    phone: string
    /** User's country. */
    country: string
    /** Type of organization. */
    organization_type: string
    /** Name of the organization. */
    organization: string
    /** Recaptcha token. */
    verify_token: string
    /** Token received from email verification. */
    email_token: string
    /** Freeform text. */
    hear_about_us?: string
  }
}
export type AuthSignupEmailApiResponse =
  /** status 200 Email verification initiated. An email has been sent if the email is not already in use. */ object
export type AuthSignupEmailApiArg = {
  body: {
    /** Email address to verify. */
    email: string
    /** Recaptcha token. */
    verify_token: string
  }
}
export type AuthEmailcheckApiResponse = /** status 200 Email availability status. */ {
  /** True if the email is available, false otherwise. */
  available: boolean
}
export type AuthEmailcheckApiArg = {
  /** The email address to check. */
  email: string
}
export type AuthSigninApiResponse = /** status 200 Signin successful */ {
  /** Token you can set in Authentication header */
  access: string
  /** If this is true the session cannot be used yet, 2FA must be checked first, with the /auth/totp endpoint. */
  totpEnabled: boolean
  /** The token is valid until this time. */
  validUntil: string
}
export type AuthSigninApiArg = {
  body: {
    /** Email address. */
    username: string
    /** Password. */
    password: string
    /** Recaptcha token. */
    verify_token: string
  }
}
export type AuthTotpApiResponse = /** status 200 Signin successful */ {
  /** New access token you can set in Authentication header */
  access?: string
  /** This will always be true. */
  totpEnabled?: boolean
  /** The token is valid until this time. */
  validUntil?: string
}
export type AuthTotpApiArg = {
  /** JWT token for TOTP verification. */
  authorization: string
  body: {
    /** Passcode from 2fa. */
    passcode?: string
    /** One of the recovery codes. */
    recovery?: string
  }
}
export type AuthPasswordResetApiResponse = /** status 200 Signin successful */ {
  /** Just a thank you. */
  message?: string
}
export type AuthPasswordResetApiArg = {
  body: {
    /** The account name. */
    email: string
  }
}
export type AuthPasswordResetChangeApiResponse = /** status 200 Signin successful */ object
export type AuthPasswordResetChangeApiArg = {
  body: {
    /** Key received via email. */
    key: string
    /** Outdated, ignored. */
    id?: string
    /** New password. */
    password1?: string
    /** New password again. */
    password2?: string
  }
}
export type SignPathsApiResponse = /** status 200 Signed tokens keyed by path */ {
  [key: string]: string
}
export type SignPathsApiArg = {
  body: {
    /** Token expiration in seconds. Defaults to 3600 when omitted. */
    expiration?: number
    /** Paths to sign. */
    paths?: string[]
  }
}
export type GetOrgBalanceApiResponse = /** status 200 Show the balance */ {
  /** Balance in USD, up to 6 digits. */
  balance: number
  /** Balance in micro USD. Divide by 1_000_000 to get dollars. */
  balanceMicro: number
  /** Balance in USD, rounded (down) to cents, always has 2 digits after the dot. */
  balanceHuman: string
  /** Autorecharge does a Credit Card transaction if the balance falls under a certain threshold. */
  autoRecharge: boolean
  /** Autorecharge threshold in USD. */
  autoRechargeThreshold: number
  /** Autorecharge amount in USD. */
  autoRechargeAmount: number
}
export type GetOrgBalanceApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
}
export type UpdateOrgBalanceApiResponse = /** status 200 OK */ {
  /** Whether Auto-Recharge is enabled after the update. */
  autoRecharge?: boolean
}
export type UpdateOrgBalanceApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Enable or disable Auto-Recharge. */
    autoRecharge: boolean
    /** Threshold balance in USD at which Auto-Recharge triggers. Required when enabling Auto-Recharge. */
    autoRechargeThreshold?: number
    /** Amount in USD to Auto-Recharge when triggered. Required when enabling Auto-Recharge. */
    autoRechargeAmount?: number
  }
}
export type GetOrgBillingApiResponse = /** status 200 All's well */ SchemaBilling
export type GetOrgBillingApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** Start of the period */
  start?: string
  /** End of the period */
  end?: string
}
export type TransferOrgFundsApiResponse = /** status 200 OK */ object
export type TransferOrgFundsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Amount in USD cents to transfer. */
    amountUSDcent: number
    /** Destination organization ID. */
    toOrgId: number
  }
}
export type ListOrgRecordingsApiResponse = /** status 200 Returns the list of call recordings. */ {
  /** Total number of recordings matching the filter criteria. */
  total?: number
  /** Array of call recording objects. */
  recordings?: SchemaRecording[]
}
export type ListOrgRecordingsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** The page number to retrieve. */
  page?: number
  /** The requested number of items on a page. */
  size?: number
  /** Filter recordings by campaign ID. If not provided, recordings from all campaigns are returned. */
  campid?: number
  /** Filter recordings by user ID. If not provided, recordings from all users are returned. */
  userid?: number
  /** Filter recordings by start timestamp. Only recordings with start_timestamp >= this value are returned. */
  startDate?: string
  /** Filter recordings by start timestamp. Only recordings with start_timestamp < this value are returned. */
  endDate?: string
}
export type DownloadOrgRecordingsApiResponse =
  /** status 200 The export request has been successfully queued. Use the returned export ID to monitor progress and download the ZIP file via the exports endpoints. */ {
    /** ID of the queued export job that will create the recordings ZIP file. */
    exportId: number
  }
export type DownloadOrgRecordingsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** The page number to retrieve. */
  page?: number
  /** The requested number of items on a page. */
  size?: number
  /** Filter recordings by campaign ID. If not provided, recordings from all campaigns are included. */
  campid?: number
  /** Filter recordings by user ID. If not provided, recordings from all users are included. */
  userid?: number
  /** Filter recordings by start timestamp. Only recordings with start_timestamp >= this value are included. */
  startDate?: string
  /** Filter recordings by start timestamp. Only recordings with start_timestamp < this value are included. */
  endDate?: string
}
export type GetOrgRecordingApiResponse = /** status 200 Returns the call recording details. */ SchemaRecordingListItem
export type GetOrgRecordingApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK recording ID. */
  recordingId: number
}
export type DownloadOrgRecordingApiResponse = /** status 200 Returns the call recording file as binary data. */ Blob
export type DownloadOrgRecordingApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK recording ID. */
  recordingId: number
}
export type ListCampaignsApiResponse = /** status 200 List of campaigns. */ {
  /** Total number of campaigns matching the filters. */
  total: number
  /** The list of campaigns. */
  engagements: SchemaCampaign[]
}
export type ListCampaignsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** 1-based page number. Defaults to 1. */
  page?: number
  /** Page size. */
  size?: number
  /** Filter by published state. */
  published?: boolean
  /** Filter by launched state. */
  launched?: boolean
  /** Filter by open state. */
  open?: boolean
  /** Filter by aborted state. */
  aborted?: boolean
  /** Filter by archived state. */
  archived?: boolean
  /** Comma separated template identifiers to include (e.g. smsblast,chatbot). */
  templates?: string
  /** Case-insensitive substring search in campaign name. */
  search?: string
}
export type CreateCampaignApiResponse = /** status 200 Campaign created */ SchemaCampaign
export type CreateCampaignApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** The type of the campaign. */
    template?:
      | 'smsblast'
      | 'smsdrip'
      | 'voiceblast'
      | 'multidrip'
      | 'ivr'
      | 'smssurvey'
      | 'whatsappsurvey'
      | 'cati'
      | 'reminder'
      | 'chatbot'
      | 'cron'
    /** Friendly name of the campaign */
    name?: string
    /** Launch time. FIXME */
    launch?: object
    /** What .open will be set to on launch. "open" campaigns can get new subscriptions. */
    launchOpen?: boolean
    /** Contacts which will be subscribed on launch. FIXME */
    contacts?: object
    /** The campaign configuration. What's accepted here depends on the selected "template" (campaign type) field, and is not documented here. */
    variables?: object
    /** Place for the UI to store fields. The backend doesn't use this. */
    uiStore?: object
    /** Times calls will go out. Only relevant for campaigns which make calls. FIXME */
    callWindow?: object
    /** Maximum number of times we try to contact someone.

        Special values: -2 means use the .callAgainCustom field, -1 means use the system default, 0 means disable.

        Only relevant for campaigns which make calls. */
    callAgainMax?: number
    /** Custom schedule for call retries. Only relevant for campaigns which make calls. FIXME */
    callAgainCustom?: object[]
    /** Maximum number of times we try to reconnect dropped calls.

        Special values: -1 means use the system default, 0 means disable.

        Only relevant for campaigns which make calls. */
    reconnectMax?: number
    /** If false: only reconnect if the user was connected for at least 10 seconds. If true: only reconnect if they reached a next part. Only relevant for campaigns which make calls and have reconnect enabled. */
    reconnectOnProgress?: boolean
    /** Is Answering Machine Detection enabled? Only relevant for campaign with make voice calls. */
    amd?: boolean
    /** Possible statuses, only relevant for CATI campaigns. */
    userStatuses?: string[]
    /** Client reference for this campaign. */
    clientRef?: string
    /** Quotas to associate with this campaign. */
    quotas?: {
      /** Unique engageSPARK ID of the quota. */
      quotaId: string
      /** Conditions for when this quota should be applied. This is a JSON logic expression. Set to null to apply the quota to all contacts. */
      conditions: any[] | null
    }[]
    /** Report field definitions for this campaign. Each report field can store custom data per subscription. */
    reportFields?: SchemaReportfield[]
  }
}
export type GetCampaignApiResponse = /** status 200 Campaign */ SchemaCampaign
export type GetCampaignApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
}
export type UpdateCampaignApiResponse = /** status 200 Campaign updated */ SchemaCampaign
export type UpdateCampaignApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
  body: {
    /** Friendly name of the campaign */
    name?: string
    /** Launch time. FIXME */
    launch?: object
    /** What .open will be set to on launch. "open" campaigns can get new subscriptions. */
    launchOpen?: boolean
    /** Contacts which will be subscribed on launch. FIXME */
    contacts?: object
    /** The campaign configuration. What's accepted here depends on the selected "template" (campaign type) field, and is not documented here. */
    variables?: object
    /** Place for the UI to store fields. The backend doesn't use this. */
    uiStore?: object
    /** Times calls will go out. Only relevant for campaigns which make calls. FIXME */
    callWindow?: object
    /** Maximum number of times we try to contact someone.

        Special values: -2 means use the .callAgainCustom field, -1 means use the system default, 0 means disable.

        Only relevant for campaigns which make calls. */
    callAgainMax?: number
    /** Custom schedule for call retries. Only relevant for campaigns which make calls. FIXME */
    callAgainCustom?: object[]
    /** Maximum number of times we try to reconnect dropped calls.

        Special values: -1 means use the system default, 0 means disable.

        Only relevant for campaigns which make calls. */
    reconnectMax?: number
    /** If false: only reconnect if the user was connected for at least 10 seconds. If true: only reconnect if they reached a next part. Only relevant for campaigns which make calls and have reconnect enabled. */
    reconnectOnProgress?: boolean
    /** Is Answering Machine Detection enabled? Only relevant for campaign with make voice calls. */
    amd?: boolean
    /** Possible statuses, only relevant for CATI campaigns. */
    userStatuses?: string[]
    /** Client reference for this campaign. */
    clientRef?: string
    /** Quotas to associate with this campaign. This replaces the entire list of quotas for the campaign. */
    quotas?: {
      /** Unique engageSPARK ID of the quota. */
      quotaId: string
      /** Conditions for when this quota should be applied. This is a JSON logic expression. Set to null to apply the quota to all contacts. */
      conditions: any[] | null
    }[]
    /** Report field definitions for this campaign. Each report field can store custom data per subscription. */
    reportFields?: SchemaReportfield[]
  }
}
export type DeleteCampaignApiResponse = /** status 200 Campaign */ {
  /** Unique engageSPARK ID of the campaign. */
  engagementId?: number
}
export type DeleteCampaignApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
}
export type SubscribeContactApiResponse = /** status 200 Subscription successful */ {
  /** Unique subscription ID assigned to the contact. */
  runId?: number
  /** ID of the contact that has been subscribed. */
  contactId?: number
}
export type SubscribeContactApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
  body: {
    /** engageSPARK ID of the contact. If provided, the contact must exist and be part of the organization. */
    contactId?: number | string
    /** Full phone number including the country code, may have a leading "+". */
    fullPhoneNumber?: string
    /** Country part of the phone number. If this is used phoneNumberCountry must also be set. */
    phoneNumber?: string
    /** Two letter ISO code of the country. Used with the "phoneNumber" option. */
    phoneNumberCountry?: string
    /** Should a contact be resubscribed if it has a previous, already finished subscription? */
    allowResubscribe?: boolean | null
    /** Overrides the timezones used to calculate message times in Drip and Reminder campaigns. */
    timeZone?: string
    delay?: SchemaSubDelay
    /** Campaign-specific arguments passed to the campaign. */
    args?: {
      [key: string]: any
    }
    /** Update the contact with the given fields before subscribing it.

        All fields are optional. Fields that are not provided will not be updated. */
    contact?: PropertiesContact
    /** Report field values to be set for this subscription. When called from an action (e.g., in a flow or callscript), both reportFieldId and value support pztemplate expansion. */
    reportFields?: SchemaReportfieldValue[]
  }
}
export type SubscribeContactsApiResponse = /** status 200 Subscription request successful */ {
  /** Number of contacts that will be processed for subscription. */
  total?: number
  /** Task ID for tracking the subscription operation. */
  taskId?: string
}
export type SubscribeContactsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
  body: {
    /** Contacts selection criteria */
    contacts: SchemaSubContacts
    delay?: SchemaSubDelay
    /** Spread out the subscription start times until this date/time. */
    startUntil?: string
    /** Overrides the timezones used to calculate message times in Drip and Reminder campaigns. */
    timeZone?: string
    /** Campaign-specific arguments passed to the campaign. */
    args?: {
      [key: string]: any
    }
    /** Should contacts be resubscribed if they have a previous, already finished subscription? */
    allowResubscribe?: boolean
    /** Report field values to be set for these subscriptions. When called from an action (e.g., in a flow or callscript), both reportFieldId and value support pztemplate expansion. */
    reportFields?: SchemaReportfieldValue[]
  }
}
export type UnsubscribeContactApiResponse = /** status 200 Unsubscribe successful */ {
  /** Subscription ID, if any. */
  runId?: number
}
export type UnsubscribeContactApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
  body: {
    /** engageSPARK ID of the contact. */
    contactId: number | string
  }
}
export type UnsubscribeContactsApiResponse = /** status 200 Unsubscribe request successful */ {
  /** Number of active subscriptions that will be cancelled. */
  total?: number
  /** Task ID for tracking the unsubscribe operation. */
  taskId?: string
}
export type UnsubscribeContactsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
  body: {
    /** Contacts selection criteria */
    contacts: SchemaSubContacts
  }
}
export type SetCampaignOpenApiResponse = /** status 200 Open state updated */ object
export type SetCampaignOpenApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
  body: {
    /** Desired open state. */
    open: boolean
  }
}
export type SetCampaignArchivedApiResponse = /** status 200 Archived state updated */ object
export type SetCampaignArchivedApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
  body: {
    /** Desired archived state. */
    archived: boolean
  }
}
export type AbortCampaignApiResponse = /** status 200 Campaign aborted */ object
export type AbortCampaignApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
}
export type CopyCampaignApiResponse = /** status 200 Campaign copied */ {
  /** ID of the newly created copied campaign. */
  engagementId: number
}
export type CopyCampaignApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
  body: {
    /** Optional name for the copied campaign. Blank means the API derives one. */
    name?: string
  }
}
export type ReopenContactsApiResponse = /** status 200 Reopen request successful. */ {
  /** Number of contacts that will be processed for reopening. */
  total: number
  /** Task ID for tracking the reopen operation. */
  taskId: string
}
export type ReopenContactsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
  body: {
    /** Contacts selection criteria. */
    contacts: SchemaSubContacts
  }
}
export type SetCampaignPublishedApiResponse = /** status 200 Published state updated */ object
export type SetCampaignPublishedApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
  body: {
    /** Desired published state. */
    published: boolean
  }
}
export type GetCampaignSummaryApiResponse = /** status 200 Campaign summary statistics. */ SchemaCampaignSummary
export type GetCampaignSummaryApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
}
export type ExportCampaignReportApiResponse = /** status 200 Report export queued. */ {
  /** ID of the queued export. */
  exportId: number
}
export type ExportCampaignReportApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
  /** If set to a timezone name (for example Asia/Manila), times in the report are given in that timezone. Otherwise UTC. */
  tz?: string
  /** Set to false to not use answer labels. */
  labels?: 'true' | 'false'
  /** Optional. By default every sheet has these contact columns: phone number, first name, and last name.

    To replace defaults, pass columns either by repeating the query argument or by using comma-separated values.

    Supported values: contact.id, contact.firstName, contact.lastName, contact.name, contact.fullPhoneNumber, contact.language, customfields.<id>.

    Passing any other column or a non-existing custom field ID returns status 400. */
  columns?: string[]
  /** Optional. Filter which report fields to include in the export.

    By default all report fields from the campaign are included.

    Pass report field IDs either by repeating the query argument or by using comma-separated values.

    Empty value means no fields are added to the report.

    Invalid report field IDs are silently ignored. */
  reportfields?: string[]
}
export type ListCampaignSubscriptionsApiResponse = /** status 200 List of subscriptions */ SchemaCampaignSubscriptions
export type ListCampaignSubscriptionsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
  /** Page number for pagination (starts at 1). */
  page?: number
  /** Number of results per page. */
  size?: number
  /** Filter by done status. */
  done?: boolean
  /** Filter by error status. */
  error?: boolean
  /** Search in contact fields. */
  search?: string
}
export type GetCampaignSubscriptionApiResponse =
  /** status 200 Campaign subscription details */ SchemaCampaignSubscription
export type GetCampaignSubscriptionApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the campaign.
    You can find this ID when editing your campaign, or copy it in the actions drop down in the campaigns list. */
  campaignId: string
  /** Unique subscription ID. */
  subId: number
}
export type GetOrgAutodeleteApiResponse = /** status 200 The prediction. */ {
  /** Total number of contacts which might get deleted (they do not have no_delete set, and are not in any group or segment which has it set). Note that we ignore "campaign subscription" status here. */
  candidates?: number
  /** Number of contacts which would actually get deleted if auto-delete is enabled now. This is the main number you want. */
  due?: number
  /** The number of days given as argument, or the default. */
  days?: number
}
export type GetOrgAutodeleteApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** Optional number of days we use as "autodelete" setting. */
  days?: number
}
export type ListContactsApiResponse = /** status 200 List of contacts */ {
  /** Total number of contacts matching the filter */
  total: number
  /** Total number of contacts in the organization */
  orgTotal: number
  /** Array of contact objects */
  contacts: SchemaContact[]
}
export type ListContactsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** The page number to retrieve. */
  page?: number
  /** The requested number of items on a page. */
  size?: number
  /** Search term to filter contacts by name or phone number */
  search?: string
  /** Filter by international phone number (E164, with optional leading +). If "region" is given this should be a local phone number. */
  phonenumber?: string
  /** Used together with phonenumber, this is the country 2 letter name. */
  region?: string
  /** Filter by group ID */
  groupid?: number
  /** Filter by no-autodelete setting */
  noautodelete?: boolean
  /** Filter by contacts which have WhatsApp Business User ID set */
  whatsappready?: boolean
  /** JSON string of custom conditions for filtering see schema_condition.yaml */
  conditions?: string
  /** Campaign ID to include subscription status information */
  subscriptionstatus?: number
  /** Filter by subscription status (requires subscriptionstatus parameter) */
  subscriptionfilter?: 'is' | 'isnot' | 'was'
}
export type CreateContactApiResponse = /** status 200 Contact created */ SchemaContact
export type CreateContactApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Full phone number including the country code, may have a leading "+". */
    fullPhoneNumber?: string
    /** Country part of the phone number. If this is used `phoneNumberCountry` must also be set. */
    phoneNumber?: string
    /** Two letter ISO code of the country. Used with the `phoneNumber` option. */
    phoneNumberCountry?: string
    /** First name of the contact. */
    firstName?: string
    /** Last name of the contact. */
    lastName?: string
    /** Language is free-form, you can use any standard or system, or leave it empty. The Language field is used in multi language campaigns to decide which version of a message or call to use. */
    language?: string
    /** List of group IDs of which this contact will be a member. Values can be either integers or the string version of integers. */
    groups?: (number | string)[]
    /** Custom field values. The keys of the object are the engageSPARK integer ID of the custom field, and the value is a free-form string. */
    customFields?: {
      [key: string]: string
    }
    /** An alternative way to set custom fields. It's the same idea as `customFields`, but the keys of the objects are the names of the custom fields. We'll use the existing group ID or create a new one if it doesn't exist.
        - names are compared case in-sensitive (so if you add "Gender", it'll re-use an existing column "gender").
        - if there are multiple possible matches, then we take the oldest existing custom field.
        - if the same custom field is used in `customFields` and `customFieldsByName`, then the value in customFieldsByName wins.
        - if the same custom field is given multiple times in `customFieldsByName` then it's not defined which one wins (`{"color": "green", "COLOR": "red"}`).
          The custom field color can now be either red or green). */
    customFieldsByName?: object
    /** Do not automatically delete this contact if contact autodeletion is enabled for this org. You can still delete it manually. */
    noAutodelete?: boolean
  }
}
export type GetContactApiResponse = /** status 200 Contact created */ SchemaContact
export type GetContactApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the contact.
    You get this ID when creating a contact. */
  contactId: string
  /** Campaign ID to include subscription status information */
  subscriptionstatus?: number
}
export type UpdateContactApiResponse = /** status 200 Contact updated */ SchemaContact
export type UpdateContactApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the contact.
    You get this ID when creating a contact. */
  contactId: string
  body: {
    /** Full phone number including the country code, may have a leading "+". */
    fullPhoneNumber?: string
    /** First name of the contact. */
    firstName?: string
    /** Last name of the contact. */
    lastName?: string
    /** Language is free form, you can use any standard or system, or leave it empty. The Language field is used in multi language campaigns to decide which version of a message or call to use. */
    language?: string
    /** List of group IDs of which this contact will be a member. Values can be either integers or the string version of integers. */
    groups?: (number | string)[]
    /** Custom field values. The keys of the object are the engageSPARK integer ID of the custom field, and the value is a free form string.
        Groups which aren't set aren't updated. Set value to an empty string to delete the value. */
    customFields?: {
      [key: string]: string
    }
    /** An alternative way to set Custom fields. It's the same idea as `customFields`, but the keys of the objects are the names of the custom fields. See the documentation in "Create Contact". */
    customFieldsByName?: object
    /** Do not automatically delete this contact if contact autodeletion is enabled for this org. You can still delete it manually. */
    noAutodelete?: boolean
  }
}
export type DeleteContactApiResponse = /** status 200 Contact deleted */ object
export type DeleteContactApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the contact.
    You get this ID when creating a contact. */
  contactId: string
}
export type GetOrgCustomfieldsApiResponse = /** status 200 List custom fields. */ {
  /** All custom fields to which you have access. */
  customfields: SchemaCustomfield[]
  /** All custom fields, including those whose values you cannot see. */
  allCustomfields: SchemaCustomfield[]
}
export type GetOrgCustomfieldsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
}
export type CreateOrgCustomfieldApiResponse = /** status 201 Custom field created. */ SchemaCustomfield & {
  /** List of engageSPARK IDs for the created custom fields. */
  ids: number[]
}
export type CreateOrgCustomfieldApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Name of the custom field. */
    name?: string
    /** List of names of the custom field. If multiple names are provided, multiple custom fields will be created. */
    names?: string[]
  }
}
export type UpdateOrgCustomfieldApiResponse = /** status 200 Custom field updated. */ SchemaCustomfield
export type UpdateOrgCustomfieldApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the customfield.
    You get this ID when creating a customfield. */
  customfieldId: string
  body: {
    /** Name of the custom field. */
    name: string
  }
}
export type DeleteOrgCustomfieldApiResponse = /** status 200 Custom field deleted. */ object
export type DeleteOrgCustomfieldApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the customfield.
    You get this ID when creating a customfield. */
  customfieldId: string
}
export type CxRequestApiResponse = /** status 200 We got the request and notified CX. */ {
  /** Internal ID of the request. */
  id: number
}
export type CxRequestApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** The request, free-form here, but in the UI it's a fixed list of options. */
    message: string
    /** Optional country argument. ISO country code. */
    country?: string
  }
}
export type ListDatatablesApiResponse = /** status 200 List of datatables */ {
  /** List of all datatables for this organization */
  tables: SchemaDatatable[]
}
export type ListDatatablesApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
}
export type GetDatatableApiResponse = /** status 200 Datatable definition */ {
  table: SchemaDatatable
}
export type GetDatatableApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** datatable name
    Set when creating a datatable. */
  datatableId: string
}
export type PopDatatableApiResponse = /** status 200 Datatable row */ {
  row: SchemaDatatableRow
}
export type PopDatatableApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** datatable name
    Set when creating a datatable. */
  datatableId: string
}
export type RowsDatatableApiResponse = /** status 200 Datatable rows */ {
  table: SchemaDatatable
  rows: SchemaDatatableRow[]
}
export type RowsDatatableApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** datatable name
    Set when creating a datatable. */
  datatableId: string
  /** Include all rows, or only popped or not-popped rows. Leave empty for all. */
  popped?: string
}
export type RowDatatableApiResponse = /** status 200 Datatable row */ {
  row: SchemaDatatableRow
}
export type RowDatatableApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** datatable name
    Set when creating a datatable. */
  datatableId: string
  /** datatable row ID */
  rowId: string
}
export type PutrowDatatableApiResponse = /** status 200 Updated datatable row */ {
  row: SchemaDatatableRow
}
export type PutrowDatatableApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** datatable name
    Set when creating a datatable. */
  datatableId: string
  /** datatable row ID */
  rowId: string
  body: {
    /** key/value of the updates. Non-listed columns are not updated. */
    values: object
  }
}
export type GetOrgDidsApiResponse = /** status 200 List phone numbers. */ {
  phoneNumbers: SchemaDidsItem[]
  /** Total number of phone numbers. */
  total: number
}
export type GetOrgDidsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
}
export type GetOrgDidApiResponse = /** status 200 Give detailed phone number info. */ {
  /** Voice call hooks for this phone number. Each hook can have conditions to filter which calls trigger its actions. */
  callHooks: null | SchemaInboundHook[]
  /** 2-letter ISO country code */
  countryCode: string
  /** When the phone number was created */
  created: string
  /** SMS/WhatsApp inbound hooks for this phone number. Each hook can have conditions to filter which messages trigger its actions. */
  hooks: null | SchemaInboundHook[]
  inboundCallCamp: null | SchemaCampaign
  /** Inbound call campaign ID, 0 for none */
  inboundCallCampId: number
  /** Name of the phone number */
  name: string
  /** The phone number */
  phoneNumber: string
  /** Price per SMS, in micro USD */
  smsPrice: number
  /** Price per SMS, in USD */
  smsPriceFloat: number
  /** Price per voice call, in micro USD */
  voicePrice: number
  /** Price per voice call, in USD */
  voicePriceFloat: number
  /** Number of seconds per voice call unit */
  voiceUnitSeconds: number
  whatsappHooks?: null | SchemaInboundHook[]
  /** Is this phone number registered with WhatsApp as a senderID? */
  whatsAppRegistered: boolean
  /** If this is true, the users can use this number to complete the whole WhatsApp Business SenderID registration process with Meta. */
  whatsAppMetaOtp?: boolean
  /** Is this phone number capable of sending SMS? */
  sms: boolean
  /** Is this phone number capable of sending WhatsApp messages? */
  whatsApp: boolean
  /** Is this phone number capable of making voice calls? */
  voice: boolean
}
export type GetOrgDidApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the DID. */
  didId: string
}
export type PostOrgDidApiResponse = /** status 200 OK */ {
  /** Phone number ID */
  id: number
}
export type PostOrgDidApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the DID. */
  didId: string
  body: {
    /** New name of the phone number */
    name?: string
    /** Unique engageSPARK ID of the campaign. Set to 0 to remove. */
    inboundCallCampId?: number
  }
}
export type PostDidRegisterWhatsAppApiResponse = /** status 200 OK */ {
  /** Always true */
  ok: boolean
  /** the Sender SID, which is for logging. */
  sid?: string
}
export type PostDidRegisterWhatsAppApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the DID. */
  didId: string
  body: {
    /** WhatsApp Business Account ID */
    wabaId: string
    /** Profile name. */
    profileName?: string
  }
}
export type CreateOrgDidHookApiResponse = /** status 200 The hook was created. */ {
  /** Hook ID. */
  id: number
}
export type CreateOrgDidHookApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the DID. */
  didId: string
  schemaInboundHookPayload: SchemaInboundHookPayload
}
export type UpdateOrgDidHookApiResponse = /** status 200 The hook was updated. */ {
  /** Hook ID */
  id: number
}
export type UpdateOrgDidHookApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the DID. */
  didId: string
  /** engageSPARK ID of the DID hook. */
  hookId: string
  schemaInboundHook: SchemaInboundHook
}
export type DeleteOrgDidHookApiResponse = /** status 200 The hook was deleted. */ object
export type DeleteOrgDidHookApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the DID. */
  didId: string
  /** engageSPARK ID of the DID hook. */
  hookId: string
}
export type CreateOrgDidCallHookApiResponse = /** status 200 The hook was created. */ {
  /** Hook ID */
  id: number
}
export type CreateOrgDidCallHookApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the DID. */
  didId: string
  schemaInboundHookPayload: SchemaInboundHookPayload
}
export type UpdateOrgDidCallHookApiResponse = /** status 200 The hook was updated. */ {
  /** Hook ID */
  id: number
}
export type UpdateOrgDidCallHookApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the DID. */
  didId: string
  /** engageSPARK ID of the DID hook. */
  hookId: string
  schemaInboundHook: SchemaInboundHook
}
export type DeleteOrgDidCallHookApiResponse = /** status 200 The hook was deleted. */ object
export type DeleteOrgDidCallHookApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the DID. */
  didId: string
  /** engageSPARK ID of the DID hook. */
  hookId: string
}
export type CreateOrgDidWaHookApiResponse = /** status 200 The hook was created. */ {
  /** Hook ID. */
  id: number
}
export type CreateOrgDidWaHookApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the DID. */
  didId: string
  schemaInboundHookPayload: SchemaInboundHookPayload
}
export type UpdateOrgDidWaHookApiResponse = /** status 200 The hook was updated. */ {
  /** Hook ID */
  id: number
}
export type UpdateOrgDidWaHookApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the DID. */
  didId: string
  /** engageSPARK ID of the DID hook. */
  hookId: string
  schemaInboundHook: SchemaInboundHook
}
export type DeleteOrgDidWaHookApiResponse = /** status 200 The hook was deleted. */ object
export type DeleteOrgDidWaHookApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the DID. */
  didId: string
  /** engageSPARK ID of the DID hook. */
  hookId: string
}
export type GetExportsListApiResponse = /** status 200 OK */ {
  total?: number
  exports?: SchemaExport[]
}
export type GetExportsListApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** The page number to retrieve. */
  page?: number
  /** The requested number of items on a page. */
  size?: number
  /** functions to include */
  functions?: string
  /** functions to exclude */
  exfunctions?: string
}
export type GetExportApiResponse = /** status 200 OK */ {
  export?: SchemaExport
}
export type GetExportApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the exported report. */
  exportId: number
}
export type DeleteExportApiResponse = /** status 200 Export deleted successfully */ object
export type DeleteExportApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the exported report. */
  exportId: number
}
export type GetExportsFileApiResponse = /** status 200 OK */ Blob
export type GetExportsFileApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the exported report. */
  exportId: number
  /** The name and extension of the file. */
  filename: string
}
export type GetFileListApiResponse = /** status 200 The list of saved files of the organization. */ SchemaFile[]
export type GetFileListApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** Optional category filter for the files. */
  category?: string
}
export type UploadFileApiResponse = /** status 200 The file was uploaded successfully. */ {
  /** The filename of the uploaded file. First file, if there are multiple files uploaded. */
  filename: string
  /** The title of the uploaded file. First file, if there are multiple files uploaded. */
  title: string
  /** Names of the originally uploaded files, with either an error or empty string. */
  results: {
    [key: string]: string
  }
  /** successfully uploaded and stored files */
  files: {
    filename: string
    title: string
    transcript: string
  }[]
}
export type UploadFileApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** The category of the file(s). */
  category: string
  /** Optionally convert audio files. Don't use this on non-audio files. The file is processed by the sox audio processor. */
  filter?: 'ogg' | 'mp3' | 'mono' | 'norm'
  /** We don't recode video, if this option is set (any value), we check if the file is compatible with whatsapp, checking against its limitations: - needs to be h264 video - needs to have aac audio - smaller than 16MB - at least a second long
    We also add a thumbnail of the video to the storage system */
  video?: boolean
  body: {
    /** The file contents to upload. Can be repeated. */
    upload: Blob[]
  }
}
export type DownloadFileApiResponse = /** status 200 The raw file data. */ Blob
export type DownloadFileApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** The name and extension of the file. */
  filename: string
}
export type UpdateFileApiResponse = /** status 200 The file was updated. */ {
  /** The filename which was passed in. */
  filename?: string
}
export type UpdateFileApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** The name and extension of the file. */
  filename: string
  body: {
    /** Audio transcript. */
    transcript?: string
  }
}
export type DeleteFileApiResponse = /** status 200 The file was deleted. */ object
export type DeleteFileApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** The name and extension of the file. */
  filename: string
}
export type GetOrgGroupsListApiResponse = /** status 200 List of groups */ {
  groups: SchemaGroup[]
  total: number
}
export type GetOrgGroupsListApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** The page number to retrieve. */
  page?: number
  /** The requested number of items on a page. */
  size?: number
  /** The field to sort by. */
  sortBy?: string
  direction?: 'ASC' | 'DESC'
  /** Filter by group type. Empty string returns all types. */
  type?: SchemaGroupType
  /** Search term to filter items by text. */
  search?: string
}
export type CreateOrgGroupApiResponse = /** status 200 The group was created. */ {
  /** Unique engageSPARK ID of the group. */
  id: number
}
export type CreateOrgGroupApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Name of the group. */
    name: string
    /** Description of the group. */
    description: string
    type: SchemaGroupType
    conditions?: null | SchemaCondition[]
    /** Do not automatically delete the contacts of this group if contact autodeletion is enabled for this org. You can still delete them manually. */
    noAutodelete: boolean
  }
}
export type GetOrgGroupApiResponse = /** status 200 Contact group found */ SchemaGroup
export type GetOrgGroupApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the contact group. */
  groupId: string
}
export type UpdateOrgGroupApiResponse = /** status 200 Contact group updated */ object
export type UpdateOrgGroupApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the contact group. */
  groupId: string
  body: {
    /** Name of the group. */
    name: string
    /** Description of the group. */
    description: string
    type: SchemaGroupType
    conditions?: null | SchemaCondition[]
    /** Do not automatically delete the contacts of this group if contact autodeletion is enabled for this org. You can still delete them manually. */
    noAutodelete?: boolean
  }
}
export type DeleteOrgGroupApiResponse = /** status 200 Contact group deleted */ object
export type DeleteOrgGroupApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the contact group. */
  groupId: string
}
export type AddOrgGroupsContactsApiResponse = /** status 200 Contacts added to group */ {
  /** number of groups we found */
  groups?: number
  /** number of contacts we found */
  contacts?: number
  /** Small number of contacts (currently < 1000) will be added real-time. If the number is larger we'll add the first few real-time, so we can check for errors, but the rest of them will be added in the background, after the call has been returned. If we do this backgroundTask will be true. If there are no (valid) contact IDs or group IDs are give the result is always a 200. */
  backgroundTask?: boolean
}
export type AddOrgGroupsContactsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** List of group IDs that the contacts will be added to. */
    groupIds: number[]
    contacts: SchemaContactsSelection
  }
}
export type DeleteOrgGroupContactsApiResponse = /** status 200 Contacts removed from group */ {
  /** Total number of remaining contacts in the group. */
  total?: number
}
export type DeleteOrgGroupContactsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the contact group. */
  groupId: string
  body: SchemaContactsSelection & {
    /** List of contact IDs that are included in the selection, it's an alias for includedContactIds. */
    contactIds?: number[]
  }
}
export type InviteCheckApiResponse = /** status 200 Invite information retrieved successfully */ {
  /** Email address of the invited user */
  email: string
  /** First name of the invited user */
  firstName: string
  /** Last name of the invited user */
  lastName: string
  /** When the invitation was created */
  created: string
  orgId: Orgid
  /** Name of the organization the user is invited to */
  orgName: string
  /** Whether the invited email belongs to an existing user */
  existingUser: boolean
  /** Whether a user is currently logged in */
  loggedIn: boolean
  /** Whether the logged in user is the same as the invited user */
  loggedInSame: boolean
  /** Role the user will have in the organization (manager, collaborator, cati_agent) */
  role: string
}
export type InviteCheckApiArg = {
  /** The invitation token to check */
  invtoken: string
}
export type InviteAcceptApiResponse = /** status 200 Invite accepted successfully */ {}
export type InviteAcceptApiArg = {
  /** The invitation token to accept */
  invtoken: string
}
export type InviteSignupAcceptApiResponse = /** status 200 User created and invite accepted successfully */ {
  /** JWT token for the new user session */
  access: string
  /** When the JWT token expires */
  validUntil: string
}
export type InviteSignupAcceptApiArg = {
  body: {
    /** The invitation token */
    token: string
    /** First name of the new user */
    first_name: string
    /** Last name of the new user */
    last_name: string
    /** Phone number (optional) */
    phone?: string
    /** Country code (optional) */
    country?: string
    /** How the user heard about the service (optional) */
    hear_about_us?: string
    /** Password for the new account */
    password: string
  }
}
export type GetOrgInvitesListApiResponse = /** status 200 List of active invites retrieved successfully */ {
  invites: SchemaOrgInvite[]
}
export type GetOrgInvitesListApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
}
export type CreateOrgInviteApiResponse = /** status 200 Invite created successfully */ {
  /** Unique identifier for the created invite */
  inviteId: number
}
export type CreateOrgInviteApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Email address of the user to invite */
    email: string
    /** First name of the user to invite */
    firstName?: string
    /** Last name of the user to invite */
    lastName?: string
    /** Role the user will have in the organization (defaults to "manager") */
    role?: 'manager' | 'collaborator' | 'cati_agent'
  }
}
export type DeleteOrgInviteApiResponse = /** status 200 Invite deleted successfully */ {}
export type DeleteOrgInviteApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** The ID of the invitation to delete */
  inviteId: number
}
export type CreateOrgBankTransferPdfApiResponse = /** status 200 Pro-forma invoice PDF. */ Blob
export type CreateOrgBankTransferPdfApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Name of the organization or payer. */
    name: string
    /** Address line 1. */
    address1: string
    /** Address line 2 (optional). */
    address2?: string
    /** City. */
    city: string
    /** State/Province/Region. */
    state: string
    /** Postal or ZIP code. */
    postalCode: string
    /** Country. */
    country: string
    /** Optional line item or note 1. */
    line1?: string
    /** Optional line item or note 2. */
    line2?: string
    /** Amount in USD. */
    amount: number
    /** Invoice date in RFC3339 format. */
    date: string
  }
}
export type GetOrgInvoiceListApiResponse = /** status 200 The list of invoices. */ {
  months?: SchemaInvoice[]
}
export type GetOrgInvoiceListApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
}
export type CreateOrganizationApiResponse = /** status 200 All is well */ {
  /** ID of the organization */
  orgId?: number
}
export type CreateOrganizationApiArg = {
  body: {
    /** Name of the organization */
    name?: string
    /** Website of the organization */
    website?: string
    /** Phone number of the organization */
    phone?: string
    /** Address of the organization */
    address?: string
    /** Country of the organization */
    country?: string
    /** Additional description for the organization address */
    location?: string
  }
}
export type GetOrganizationApiResponse = /** status 200 OK */ SchemaOrg
export type GetOrganizationApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
}
export type UpdateOrganizationApiResponse = /** status 200 OK */ {
  orgId?: Orgid
}
export type UpdateOrganizationApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Name of the organization. */
    name?: string
    /** Website of the organization. */
    website?: string
    /** Phone number of the organization. */
    phone?: string
    /** Address of the organization. */
    address?: string
    /** Country of the organization. */
    country?: string
    /** Additional description for the organization address. */
    location?: string
    /** The minimum amount of money spent that triggers a notification to be sent to the organization. A 0 value means no notification will be sent. */
    spendNotification?: number
    /** The low balance notification that triggers when the organization's balance is below this amount. */
    balanceNotification?: number
    /** The maximum amount of money that can be spent by the organization in a day. A 0 value means no limit. */
    maxDailySpend?: number
    /** Enable automatically deleting unused contacts. */
    contactsAutodelete?: boolean
    /** Days for .contactsAutodelete . Value must be set only if .contactsAutodelete is enabled, and must be > 0. */
    contactsAutodeleteDays?: number
    /** Does every user need to setup 2FA? */
    totpRequired?: boolean
  }
}
export type GetOrgPlanApiResponse = /** status 200 Organization plan details retrieved successfully. */ SchemaOrgPlan
export type GetOrgPlanApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
}
export type UpdateOrgPlanApiResponse = /** status 200 Plan updated successfully. */ {
  /** ID of the plan */
  planId: number
  /** Action performed on the plan */
  action: 'new' | 'upgrade' | 'downgrade' | 'undo'
}
export type UpdateOrgPlanApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** ID of the plan to switch to */
    planId: number
    /** Billing frequency (monthly or yearly) */
    billing: 'monthly' | 'yearly'
    /** Whether to undo a previous plan cancellation */
    undoCancel: boolean
    /** Whether to undo a scheduled plan downgrade */
    undoDowngrade: boolean
  }
}
export type CancelOrgPlanApiResponse = /** status 200 Plan cancelled successfully. */ {
  /** ID of the cancelled plan */
  planId: number
}
export type CancelOrgPlanApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
}
export type GetOrgPaymentsCreditCardsApiResponse = /** status 200 List of saved credit cards */ {
  /** Credit card ID */
  id: number
  /** Human-friendly label for the card */
  label: string
}[]
export type GetOrgPaymentsCreditCardsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
}
export type PostOrgPaymentsCreditCardsApiResponse = /** status 201 Card added successfully */ {
  /** New credit card ID */
  id: number
  label: string
}
export type PostOrgPaymentsCreditCardsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Human-friendly label shown in the UI */
    label: string
    /** Stripe Source/Token ID created via Stripe.js or mobile SDKs */
    stripeSourceId: string
  }
}
export type DeleteOrgPaymentsCreditCardApiResponse = /** status 205 Card deleted */ {}
export type DeleteOrgPaymentsCreditCardApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** ID of the credit card on file. */
  ccid: string
}
export type PostOrgPaymentsCreditCardChargeApiResponse = /** status 201 Charge created */ {
  status: string
}
export type PostOrgPaymentsCreditCardChargeApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** ID of the credit card on file. */
  ccid: string
  body: {
    /** Amount to charge, in US cents. Min 1000, max 200000. */
    amountUSDcent: number
  }
}
export type GetOrgPhonenumberApiResponse = /** status 200 Give phone number info. */ {
  /** This is a valid phone number (full-number version). Note that this does not mean this number is in use or active. */
  isValid?: boolean
  /** engageSPARK supports this phone number range. If not, messages will fail. If the range is supported, it usually means that we can send to this number—but that's not guaranteed. If you want to be sure if a particular route is supported, please reach out to support. */
  hasCarrier?: boolean
  /** This is a valid phone number (region version). */
  isValidForRegion?: boolean
  /** Description what kind of phone number this is. Common options are "mobile", "fixedline", "fixedlineormobile", "premium", "tollfree". */
  phoneNumberType?: string
  /** 2 letter ISO country this phone number belongs to. Only set when "hasCarrier" is true. */
  countryIso?: string
  /** Phone number formatted as E164 number, no leading "+". */
  phoneNumberE164?: string
  /** Phone number as E164 number, but with known migrations applied. */
  phoneNumberFixed?: string
  /** Relevant only for WhatsApp numbers. If this is set this number is registered with Meta. */
  whatsAppRegistered?: boolean
}
export type GetOrgPhonenumberApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** The phone number, either the full number, with country code, or only the national part, if "region" parameter is set. Can have a leading "+". */
  phonenumber?: string
  /** Only set this if "phonenumber" is not a full international phone number. Region is the 2-letter ISO country code. */
  region?: string
}
export type GetBlockListApiResponse = /** status 200 The list of blocks. */ {
  count?: number
  blocks?: SchemaBlock[]
}
export type GetBlockListApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
}
export type CreateBlockApiResponse = /** status 200 OK */ {
  /** The id of the saved block. Could be an existing ID if this is a duplicate phone number. */
  id?: string
  /** Repeats the phone number you added. */
  phoneNumber?: string
}
export type CreateBlockApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Phone Number, international, without leading + */
    phoneNumber: string
    /** Freeform reason. */
    why: string
  }
}
export type GetBlockApiResponse = /** status 200 The phone number blocks. */ {
  block?: SchemaBlock
}
export type GetBlockApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the phone number block. */
  blockId: string
}
export type DeleteBlockApiResponse = /** status 200 OK */ {
  /** The id of the deleted phone number block. */
  id?: string
}
export type DeleteBlockApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the phone number block. */
  blockId: string
}
export type GetOrgPurchaseListApiResponse = /** status 200 The list of purchases. */ SchemaPurchase[]
export type GetOrgPurchaseListApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
}
export type CreateOrgReportApiResponse = /** status 200 OK. All fields look good and we have queued the request. */ {
  /** ID of the report */
  exportId?: number
}
export type CreateOrgReportApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Which report. See main docs above for the list. */
    function: string
    /** Used in report "smsreport": year/month the report is about, cannot be before 2022. */
    month?: string
    /** Used in the "orgspend" report. */
    orgreport?: {
      /** either empty ("forever"), or "month". */
      grouping: '' | 'month'
      /** Limit the data */
      filter?: {
        /** Only use records from these campaigns. All campaigns if empty. */
        campaignIds?: number[]
        /** Limit the date */
        date?: {
          /** On or after this time. No timezone or seconds. */
          from?: string
          /** Before this time. No timezone or seconds. */
          until?: string
          /** Valid time zone. */
          tz?: string
        }
      }
    }
  }
}
export type GetOrgSenderIdsApiResponse = /** status 200 List sender IDs. */ {
  sms: SchemaSenderid[]
  voice: SchemaSenderid[]
  whatsapp: SchemaSenderid[]
}
export type GetOrgSenderIdsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
}
export type SendOrgSmsContactsApiResponse =
  /** status 200 OK. Batch accepted. Individual messages may still contain per-message errors. */ {
    /** Empty on success. */
    error: string
    /** Optional machine-readable error code for batch-level errors. */
    errorCode?: string
    /** Estimated total batch cost in millionths of a dollar. */
    estimateMicro: number
    /** Estimated total batch cost in USD, rounded down to cents. */
    estimate: string
    /** Number of messages queued for delivery. */
    acceptedMessages: number
    /** Deadline until which delivery retries may happen. */
    deliveryDeadline: string
    messages: {
      /** engageSPARK message ID. */
      id: string
      /** Estimated message cost in millionths of a dollar. */
      estimateMicro: number
      /** Estimated message cost in USD. */
      estimate: string
      /** ID of the contact this message was generated for. */
      contactId?: number
      /** Per-message error. Empty if accepted. */
      error: string
      /** Optional machine-readable per-message error code. */
      errorCode?: string
    }[]
  }
export type SendOrgSmsContactsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Sender ID. Must be a valid sender ID or phone number for the organization. */
    from?: string
    /** The content of the SMS to send to all selected contacts. Personalized templates are supported. */
    message: string
    contacts: SchemaContactsSelection
  }
}
export type SendSmsContactApiResponse =
  /** status 200 OK. All fields look good and we've queued the message for delivery. */ SchemaSms
export type SendSmsContactApiArg = {
  body: {
    /** ID of the organization. It can be a string or a number. You can find it in your [Organization Profile](https://app.engagespark.com/organization/info). */
    orgId: number | string
    /** Sender ID. In general these need to be set, unless you use a default one. */
    from: string
    /** The content of the message. A message can be up to 7 parts long; longer messages will be rejected.

        You can personalize the SMS using the contact's data, for example the first name. Example: `Hello {{contact.firstName}}`

        In many countries, Unicode characters can be used. However, country-specific GSM 03.38 code pages are generally not supported.

        ⚠️ Please note that when using unicode-characters, the SMS length calculation changes. Read more about [SMS character limits](https://www.engagespark.com/support/sms-character-limit/). */
    message: string
    /** If not empty; if we have already sent a message with the given value we won't send the message again. This is useful when a POST failed due to network errors. */
    clientDedup?: string
    /** Whenever we receive a delivery receipt we POST to this URL. */
    clientPushURL?: string
    /** ID we'll return in lists of SMSs. The ID can be anything and doesn't need to be unique. engageSPARK doesn't do anything with this. */
    clientRef?: string
    /** engageSPARK ID of the contact. If provided, the contact must exist and be part of the organization. */
    contactId?: number | string
    /** Full phone number including the country code; it may have a leading "+".

        This number needs to have an international dialing code.

        For example, for a number from the Philippines (with the dialing code 63), 639123456789 would be correct, whereas 9123456789 would be missing the dialing code. If you are not sure about the dialing code of the country you want to send calls or SMS to, [check this Wikipedia article](https://en.wikipedia.org/wiki/List_of_country_calling_codes#Ordered_by_code) on dialing codes. */
    fullPhoneNumber?: string
    /** Country part of the phone number. If this is used phoneNumberCountry must also be set. */
    phoneNumber?: string
    /** Two-letter ISO code of the country. Used with the "phoneNumber" option. */
    phoneNumberCountry?: string
    /** Legacy; same as "fullPhoneNumber". */
    to?: string
  }
}
export type SendSmsPhonenumberApiResponse =
  /** status 200 OK. All fields look good and we've queued the message for delivery. */ SchemaSms
export type SendSmsPhonenumberApiArg = {
  body: {
    /** ID of the organization. It can be a string or a number. You can find it in your [Organization Profile](https://app.engagespark.com/organization/info). */
    orgId: number | string
    /** Sender ID. In general these need to be set, unless you use a default one. */
    from: string
    /** The content of the message. A message can be up to 7 parts long; longer messages will be rejected.

        Personalized messages are not supported in this API.

        In many countries, Unicode characters can be used. Country-specific GSM 03.38 code pages, however, are generally not supported.

        ⚠️ Please note that when using unicode-characters, the SMS length calculation changes. Read more about [SMS character limits](https://www.engagespark.com/support/sms-character-limit/). */
    message: string
    /** If not empty; if we already send a message with the given value we won't send a message again. Useful when a POST failed thanks to network errors. */
    clientDedup?: string
    /** Whenever we get a delivery receipt we POST to this URL. */
    clientPushURL?: string
    /** ID we'll return in lists of SMSs. Can be anything and doesn't need to be unique. engageSPARK doesn't do anything with this. */
    clientRef?: string
    /** Full phone number including the country code, may have a leading "+". */
    fullPhoneNumber?: string
    /** Country part of the phone number. If this is used phoneNumberCountry must also be set. */
    phoneNumber?: string
    /** Two letter ISO code of the country. Used with the "phoneNumber" option. */
    phoneNumberCountry?: string
    /** Legacy, same as "fullPhoneNumber". */
    to?: string
  }
}
export type SendWhatsAppContactApiResponse =
  /** status 200 OK. All fields look good and we've queued the message for delivery. */ {
    /** ID of the sent message. */
    messageId?: string
    /** ID of the contact. */
    contactId?: number
    /** Recipient phone number. */
    to?: string
    /** The message content. */
    message?: string
    /** Expanded template content. */
    content?: object
    /** Deadline for message delivery attempts. */
    deliveryDeadline?: string
  }
export type SendWhatsAppContactApiArg = {
  body: {
    /** ID of the organization. It can be a string or a number. You can find it in your [Organization Profile](https://app.engagespark.com/organization/info). */
    orgId: number | string
    /** Sender phone number. Must be a WhatsApp Business Account phone number registered with engageSPARK. */
    from: string
    /** The content of the message. You can personalize the message using the contact's data. Example: `Hello {{contact.firstName}}` */
    message: string
    /** local file reference for an image to send. */
    image?: string
    /** local file reference for an audio file to send. */
    audio?: string
    /** local file reference for a video file to send. */
    video?: string
    /** local file reference for a document to send. */
    document?: string
    /** Structured content for template messages. */
    content?: object
    /** engageSPARK ID of the contact. If provided, the contact must exist and be part of the organization. */
    contactId?: number | string
    /** Full phone number including the country code; it may have a leading "+".
        This number needs to have an international dialing code.
        For example, for a number from the Philippines (with the dialing code 63), 639123456789 would be correct, whereas 9123456789 would be missing the dialing code. */
    fullPhoneNumber?: string
    /** Country part of the phone number. If this is used phoneNumberCountry must also be set. */
    phoneNumber?: string
    /** Two-letter ISO code of the country. Used with the "phoneNumber" option. */
    phoneNumberCountry?: string
  }
}
export type GetSmsListApiResponse = /** status 200 OK. */ {
  /** The SMSs */
  messages: SchemaModelSms[]
  /** if true there are older SMSs. */
  hasNextPage?: boolean
  /** repeat the call with this value a "&after=" argument to get the next page. */
  nextPage?: string
  /** if true we used ?page and ?size, not ?after. If this is true then .nextPage and .hasNextPage won't be set. */
  paged: boolean
}
export type GetSmsListApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** See "nextPage" in the response. */
  after?: string
  /** Maximum number of results per API call. */
  limit?: number
  /** Show this page. Starts at 1! */
  page?: string
  /** Used when ?page is set. The default and the maximum is 1000. */
  size?: string
  /** Limit to only egress, only ingress, or all directions. An empty value is the same as "all". */
  dir?: 'inbound' | 'outbound' | 'all'
  /** Limit to/exclude failed deliveries. Failed means the message didn't get delivered at all. Delivery Receipts are not taken into account here. An empty value is the same as "all". */
  failed?: 'true' | 'false' | 'all'
  /** Keyword search in the message, sender, receiver, and contact fields. */
  search?: string
  /** The creation time of the message must be >= this timestamp. */
  startDate?: string
  /** The creation time of the message must be < this timestamp. */
  endDate?: string
}
export type GetSmsApiResponse = /** status 200 OK. We have the SMS. */ SchemaModelSms
export type GetSmsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** ID of the SMS. */
  messageId: string
}
export type GetSnippetListApiResponse = /** status 200 The list of snippets. */ {
  snippets: SchemaSnippet[]
}
export type GetSnippetListApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** When this key is present, all organization snippets will be returned. By default, only a user's own snippets are listed. */
  all?: boolean
  /** Filter returned snippets by category. */
  category?: string
}
export type CreateSnippetApiResponse = /** status 200 OK */ {
  /** The id of the saved snippet */
  id?: number
}
export type CreateSnippetApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Name of the snippet category. */
    category?: string
    snippet?:
      | {
          [key: string]: any
        }
      | {
          [key: string]: any
        }[]
    referencedFiles?: string[]
    referencedCampaigns?: number[]
    referencedContacts?: number[]
  }
}
export type GetSnippetApiResponse = /** status 200 The data of the snippet */ SchemaSnippet
export type GetSnippetApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of a snippet. */
  snippetId: string
}
export type UpdateSnippetApiResponse = /** status 200 The data of the snippet */ {
  /** The id of the updated snippet */
  id?: number
}
export type UpdateSnippetApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of a snippet. */
  snippetId: string
  body: {
    category?: string
    snippet?: {
      [key: string]: any
    }
    userId?: number
    /** To remove references, update with an explicit empty list. */
    referencedFiles?: string[]
    /** To remove references, update with an explicit empty list. */
    referencedCampaigns?: number[]
    /** To remove references, update with an explicit empty list. */
    referencedContacts?: number[]
  }
}
export type DeleteSnippetApiResponse = /** status 200 The data of the snippet */ object
export type DeleteSnippetApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of a snippet. */
  snippetId: string
}
export type UpdateSubscriptionsApiResponse = /** status 200 Update successful */ {
  /** Number of subscriptions that matched the filter. */
  matched?: number
  /** IDs of subscriptions that were updated. */
  subIds?: number[]
}
export type UpdateSubscriptionsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** User-defined status for the subscriptions. */
    userStatus?: string
    /** Update subscriptions for this contact ID. */
    contactId?: number
    /** Update subscriptions for these contact IDs. */
    contactIds?: number[]
    /** Update subscriptions for this campaign ID. */
    campaignId?: number
    /** Report field values to set. Empty values delete the field. */
    reportFields?: SchemaReportfieldValue[]
  }
}
export type UpdateSubscriptionApiResponse = /** status 200 Update successful */ {
  sub?: SchemaSubscription
}
export type UpdateSubscriptionApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the subscription. */
  subId: string
  body: {
    /** User-defined status for the subscription. */
    userStatus?: string
    /** Report field values to set. Empty values delete the field. */
    reportFields?: SchemaReportfieldValue[]
  }
}
export type SubsReopenApiResponse = /** status 200 Reopen successful */ {
  /** Always true, just to have something. */
  okay?: boolean
}
export type SubsReopenApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the subscription. */
  subId: string
  body: object
}
export type CreateSpeechPreviewApiResponse = /** status 200 OK */ Blob
export type CreateSpeechPreviewApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Text to convert to speech. */
    what: string
    /** Optional voice id based on the available voices (https://api.engagespark.com/system/voices). */
    voice?: string
  }
}
export type SendOrgTopupApiResponse =
  /** status 200 OK. All fields look good and we have executed the top-up. */
  | {
      /** engageSPARK ID */
      id?: string
      /** The currency we used. */
      currency?: string
      /** The amount the user got on their phone. */
      amountSent?: number
      /** What you got charged. */
      price?: number
      /** Always false for status '200', always true for status '202'. */
      queued?: boolean
    }
  | /** status 202 Queued.

Either "async" was set, or we did not manage to do the top-up right away. The top-up will be retried a few more times for a maximum of 5 hours.

The exact schedule:

 - 1st retry: scheduled 1 minute after the initial request

 - 2nd retry: scheduled 2 minutes after the previous request

 - 3rd retry: scheduled 5 minutes after the previous request

 - 4th retry: scheduled 30 minutes after the previous request

 - 5th retry: scheduled 60 minutes after the previous request

 - 6th retry: scheduled 120 minutes after the previous request */ {
      /** engageSPARK ID */
      id?: string
      /** The currency we used. */
      currency?: string
      /** The amount the user got on their phone. */
      amountSent?: number
      /** What you got charged. */
      price?: number
      /** Always false for status '200', always true for status '202'. */
      queued?: boolean
    }
export type SendOrgTopupApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** We make the topup closest to this amount (but not over). See the request description for examples and a more in-depth discussion. */
    maxAmount: number | string
    /** We try to use the top-up closest to this amount. Optional but recommended. See the request description for examples and a more in-depth discussion. */
    desiredAmount?: number | string
    /** ID we will return in lists of top-ups. It can be anything and does not need to be unique. engageSPARK does not do anything with this. */
    clientRef?: string
    /** If not set or false we will not return until the topup is finished. Since this can take up to 10 minutes this might cause problems with timeouts. It is recommended to set async to true, and then check the result. */
    async?: boolean
    /** If true we do not do the actual top-up, but we return what we would have done. */
    test?: boolean
    /** engageSPARK ID of the contact. */
    contactId?: number | string
    /** Full phone number including the country code, may have a leading "+". */
    fullPhoneNumber?: string
    /** Country part of the phone number. If this is used phoneNumberCountry must also be set. */
    phoneNumber?: string
    /** Two letter ISO code of the country. Used with the "phoneNumber" option. */
    phoneNumberCountry?: string
  }
}
export type GetOrgTopupsListApiResponse = /** status 200 OK. Here are your top-ups. */ {
  /** The top-ups */
  topups: SchemaTopup[]
  /** if true there are older top-ups. */
  hasNextPage?: boolean
  /** repeat the call with this value a "&after=" argument to get the next page. */
  nextPage?: string
  /** if true we used ?page and ?size, not ?after. If this is true then .nextPage and .hasNextPage won't be set. */
  paged: boolean
}
export type GetOrgTopupsListApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** See "nextPage" in the response. */
  after?: string
  /** Maximum number of results per API call. */
  limit?: number
  /** Show this page. Starts at 1! */
  page?: string
  /** Used when ?page is set. The default and the maximum is 1000. */
  size?: string
  /** Limit to/exclude failed Top-Ups. */
  failed?: 'true' | 'false' | 'all'
  /** Keyword search in the contact fields. */
  search?: string
  /** Create time of the Top-Up must be >= this timestamp. */
  startDate?: string
  /** Create time of the Top-Up must be < this timestamp. */
  endDate?: string
}
export type GetOrgTopupsApiResponse = /** status 200 OK. We have the Top-Up. */ SchemaTopup
export type GetOrgTopupsApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** ID of the Top-Up. */
  topupId: string
}
export type ListOrgQuotasApiResponse = /** status 200 List of quotas */ {
  /** Total number of quotas. */
  count: number
  quotas: SchemaQuota[]
}
export type ListOrgQuotasApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** Filter quotas by campaign ID. */
  campid?: number
}
export type CreateOrgQuotaApiResponse = /** status 200 The quota was created successfully. */ {
  /** Unique engageSPARK ID of the newly created quota. */
  id: string
  /** Name of the quota. */
  name: string
}
export type CreateOrgQuotaApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  schemaQuotaAdd: SchemaQuotaAdd
}
export type GetOrgQuotaApiResponse = /** status 200 Quota details */ {
  quota: SchemaQuota
}
export type GetOrgQuotaApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the quota. */
  quotaId: string
}
export type UpdateOrgQuotaApiResponse = /** status 200 The quota was updated successfully. */ {
  /** Unique engageSPARK ID of the updated quota. */
  id: string
}
export type UpdateOrgQuotaApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the quota. */
  quotaId: string
  schemaQuotaEdit: SchemaQuotaEdit
}
export type DeleteOrgQuotaApiResponse = /** status 200 The quota was deleted successfully. */ {
  /** Unique engageSPARK ID of the deleted quota. */
  id: string
}
export type DeleteOrgQuotaApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of the quota. */
  quotaId: string
}
export type TranscribeFileApiResponse = /** status 200 The transcript */ {
  /** The transcript. */
  transcript?: string
}
export type TranscribeFileApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  body: {
    /** Stored file name. */
    filename: string
    /** Language, the `transcribe` attribute from api.es/system/transcribe */
    language: string
    /** If true the transcript will be stored with the file. */
    store?: boolean
  }
}
export type GetUserApiResponse = /** status 200 Successful response. */ SchemaUserWithOrgs
export type GetUserApiArg = void
export type SaveUserApiResponse = /** status 200 Successful response. */ SchemaUserWithOrgs
export type SaveUserApiArg = {
  body: {
    /** First name of the user. */
    firstName?: string
    /** Last name of the user. */
    lastName?: string
    /** Phone number of the user. */
    phone?: string
    /** Country of the user. */
    country?: string
    /** Local timezone of the user. */
    localTimezone?: string
    /** Organization ID to set as active. If present, user will switch active org. */
    activeOrgId?: number
    /** Current password (required when changing password). */
    currentPassword?: string
    /** New password. */
    newPassword?: string
    /** Repeat of new password. */
    newPasswordAgain?: string
    /** UI store data for the user (raw JSON payload). */
    uiStore?: object
  }
}
export type UserFeedbackApiResponse = /** status 200 Feedback received */ {}
export type UserFeedbackApiArg = {
  body: {
    /** optional subject */
    subject?: string
    /** the message */
    message: string
  }
}
export type GetUserTotpApiResponse = /** status 200 TOTP registration data */ {
  /** Secret for configuring an authenticator app. */
  secret: string
  /** Base64 encoded PNG image suitable for embedding as data:image/png;base64,PNG */
  png: string
}
export type GetUserTotpApiArg = void
export type SetUserTotpApiResponse = /** status 200 TOTP enabled */ {
  recoveryCodes: string[]
  /** New access token you can set in Authentication header */
  access: string
}
export type SetUserTotpApiArg = {
  body: {
    /** Secret from a previous GET */
    secret: string
    /** Passcode from the authenticator app */
    passcode: string
  }
}
export type DisableUserTotpApiResponse = /** status 200 TOTP disabled */ object
export type DisableUserTotpApiArg = void
export type GetUserRecoveryCodesApiResponse = /** status 200 Current recovery codes */ {
  /** List of recovery codes */
  recoveryCodes: string[]
}
export type GetUserRecoveryCodesApiArg = void
export type NewUserRecoveryCodesApiResponse = /** status 200 New recovery codes */ {
  /** Newly generated recovery codes */
  recoveryCodes: string[]
}
export type NewUserRecoveryCodesApiArg = void
export type ListUserAuthTokensApiResponse = /** status 200 List of tokens. */ {
  /** Total number of tokens (including deleted) */
  total: number
  /** List of auth tokens (deleted tokens remain in the list) */
  tokens: SchemaAuthtoken[]
}
export type ListUserAuthTokensApiArg = void
export type CreateUserAuthTokenApiResponse = /** status 200 Created token. */ {
  token: SchemaAuthtoken
}
export type CreateUserAuthTokenApiArg = void
export type GetUserAuthTokenApiResponse = /** status 200 Token metadata */ {
  token: SchemaAuthtoken
}
export type GetUserAuthTokenApiArg = {
  /** API token ID */
  tokenId: number
}
export type UpdateUserAuthTokenApiResponse = /** status 200 Updated token metadata */ {
  token?: SchemaAuthtoken
}
export type UpdateUserAuthTokenApiArg = {
  /** API token ID */
  tokenId: number
  body: {
    name?: string
    expires?: string
    active?: boolean
  }
}
export type DeleteUserAuthTokenApiResponse = /** status 200 Deletion successful (empty response) */ {}
export type DeleteUserAuthTokenApiArg = {
  tokenId: number
}
export type GetOrgUserListApiResponse =
  /** status 200 The full list of users which have access to the organization. */ {
    /** The list of users of the organization. */
    users: SchemaOrgUser[]
  }
export type GetOrgUserListApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
}
export type GetOrgUserApiResponse = /** status 200 The organization user's details. */ SchemaOrgUser
export type GetOrgUserApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of a user. */
  userId: string
}
export type UpdateOrgUserApiResponse = /** status 200 OK */ SchemaOrgUser
export type UpdateOrgUserApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of a user. */
  userId: string
  /** Update the permissions of a user in relation to the organization.
    Supported fields: - role: string (role of the user) - notify: bool (email notifications) - fullAccess: bool - readGroupAll: bool - readGroupIds: int list - readCustomFieldAll: bool - readCustomFieldIds: int list - readFields: string list - uiStore: object (arbitrary UI data to store per user)
    Not adding a field keeps the old value. readGroupIds needs to be set to [] to clear, null doesn't work. */
  body: {
    /** Role of the user in the organization. */
    role?: 'owner' | 'manager' | 'collaborator' | 'report_viewer' | 'cati_agent' | 'customer_service'
    /** If true, the user will receive email notifications for some events in the organization. */
    notify?: boolean
    /** Whether the user has full access to the organization. */
    fullAccess?: boolean
    /** If true, the user has read access to all groups. */
    readGroupAll?: boolean
    /** The IDs of the groups the user can read. */
    readGroupIds?: number[]
    /** If true, the user has read access to all custom fields. */
    readCustomFieldAll?: boolean
    /** The IDs of the custom fields the user can read. */
    readCustomFieldIds?: number[]
    /** List of contact fields the user can see. */
    readFields?: string[]
    /** UI store data for the user. */
    uiStore?: object
  }
}
export type DeleteOrgUserApiResponse = /** status 200 OK */ {
  /** If true, the user has been successfully deleted. */
  success?: boolean
}
export type DeleteOrgUserApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** engageSPARK ID of a user. */
  userId: string
}
export type GetWhatsAppListApiResponse = /** status 200 OK. */ {
  /** The WhatsApp messages */
  messages: SchemaModelWhatsapp[]
  /** if true there are older WhatsApp messages. */
  hasNextPage?: boolean
  /** repeat the call with this value a "&after=" argument to get the next page. */
  nextPage?: string
  /** if true we used ?page and ?size, not ?after. If this is true then .nextPage and .hasNextPage won't be set. */
  paged: boolean
}
export type GetWhatsAppListApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** See "nextPage" in the response. */
  after?: string
  /** Maximum number of results per API call. */
  limit?: number
  /** Show this page. Starts at 1! */
  page?: string
  /** Used when ?page is set. The default and the maximum is 1000. */
  size?: string
  /** Limit to only egress, only ingress, or all directions. An empty value is the same as "all". */
  dir?: 'inbound' | 'outbound' | 'all'
  /** Limit to/exclude failed deliveries. Failed means the message didn't get delivered at all. Delivery Receipts are not taken into account here. An empty value is the same as "all". */
  failed?: 'true' | 'false' | 'all'
  /** Keyword search in the message, sender, receiver, and contact fields. */
  search?: string
  /** The creation time of the message must be >= this timestamp. */
  startDate?: string
  /** The creation time of the message must be < this timestamp. */
  endDate?: string
}
export type GetWhatsAppApiResponse = /** status 200 OK. We have the message. */ SchemaModelWhatsapp
export type GetWhatsAppApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** ID of the WhatsApp message. */
  messageId: string
  /** If greater than 0, include imageUrls, audioUrls, videoUrls, and documentUrls with temporary access tokens. Tokens are valid for this many seconds (max 24 hours = 86400 seconds). */
  sign?: number
}
export type ExportWhatsAppApiResponse = /** status 200 The Excel file with the WhatsApp messages. */ Blob
export type ExportWhatsAppApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** Timezone for the export. Must be a valid timezone identifier (e.g., "America/New_York", "UTC"). */
  tz: string
  /** Limit to only egress, only ingress, or all directions. An empty value is the same as "all". */
  dir?: 'inbound' | 'outbound' | 'all'
  /** Limit to/exclude failed deliveries. Failed means the message didn't get delivered at all. Delivery Receipts are not taken into account here. An empty value is the same as "all". */
  failed?: 'true' | 'false' | 'all'
  /** The creation time of the message must be >= this timestamp. */
  startDate?: string
  /** The creation time of the message must be < this timestamp. */
  endDate?: string
}
export type GetOrgWaTemplatesListApiResponse = /** status 200 WhatsApp templates. */ {
  /** The templates */
  templates?: SchemaWatemplate[]
}
export type GetOrgWaTemplatesListApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** if set to "true" or "false" */
  register?: string
  /** if set to "true" or "false" */
  approved?: string
}
export type GetOrgWaTemplatesGetApiResponse = /** status 200 The WhatsApp template. */ SchemaWatemplate
export type GetOrgWaTemplatesGetApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** ID of the WhatsApp template */
  id: string
}
export type GetOrgWaTemplatesRefreshApiResponse = unknown
export type GetOrgWaTemplatesRefreshApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** ID of the WhatsApp template */
  id: string
  body: object
}
export type GetOrgWaTemplatesRegisterApiResponse =
  /** status 200 Deletes the old SID and registers it again (with the new example fields). */ {
    /** The original SID is deleted, and it is replaced by this new one. The ID stays the same. */
    newSid: string
  }
export type GetOrgWaTemplatesRegisterApiArg = {
  /** engageSPARK ID of the organization.
    You can find this ID in your [Organization Profile](https://app.engagespark.com/organization/info). */
  orgId: string
  /** ID of the WhatsApp template */
  id: string
  body: {
    /** The WhatsApp category. If left empty we'll use the one it already has. */
    category: '' | 'UTILITY' | 'MARKETING'
    /** Example contact, which helps with getting templates approved by Meta. */
    exampleContact?: SchemaContact
  }
}
export type SchemaPricing = {
  /** The name of the carrier. */
  carrierName?: string
  /** The currency used for the requested country, e.g. PHP. */
  productCurrency?: string
  /** The value of a topup. */
  productValue?: number
  /** The price in USD. */
  retailPriceUSD?: number
}
export type SchemaBilling = {
  /** Start of the period */
  start?: string
  /** End of the period */
  end?: string
  smsStats?: {
    /** Total number of SMS sent. */
    total: number
    /** Total cost in USD * 1m. */
    costMicro: number
    /** Total cost in USD. */
    costHuman: string
    /** Number of total SMS sent. */
    totalEgress: number
    /** Number of SMS that failed to be delivered to the telco. */
    deliveredToTelcoFailed: number
    /** Number of SMS with an unknown delivery status. */
    deliveredToPhoneUnknown: number
    /** Number of SMS that failed to be delivered to the target device. */
    deliveredToPhoneFailed: number
    /** Number of SMS that were successfully delivered to the target device. */
    deliveredToPhoneConfirmed: number
    /** Number of SMS that are still being processed. */
    inProgress: number
    /** Number of SMS received. */
    totalIngress: number
  }
  whatsappStats?: {
    /** Total number of WhatsApp messages sent. */
    total?: number
    /** Total cost in USD / 1m. */
    costMicro?: number
    /** Total cost in USD. */
    costHuman?: string
    /** Number of total WhatsApp messages sent. */
    totalEgress?: number
    /** Number of successful WhatsApp messages sent. */
    success?: number
    /** Number of failed WhatsApp messages sent. */
    failed?: number
    /** Number of WhatsApp messages still being processed. */
    inProgress?: number
    /** Number of WhatsApp messages received. */
    totalIngress?: number
  }
  voiceStats?: {
    /** Total number of voice calls. */
    total?: number
    /** Total cost in USD / 1m. */
    costMicro?: number
    /** Total cost in USD. */
    costHuman?: string
    /** The total duration of all voice calls in seconds. */
    seconds?: number
    /** Number of total outgoing voice calls. */
    totalEgress?: number
    /** Total duration of outgoing voice calls in seconds. */
    secondsEgress?: number
    /** Number of redialed voice calls. */
    callAgain?: number
    /** Number of voice calls that failed to ring. */
    failedToRing?: number
    /** Number of voice calls that were not answered. */
    notAnswered?: number
    /** Number of voice calls that were answered. */
    answered?: number
    /** Number of voice calls received. */
    totalIngress?: number
    /** Total duration of voice calls received in seconds. */
    secondsIngress?: number
  }
}
export type SchemaRecordingListItem = {
  /** engageSPARK recording ID. */
  id: number
  /** Call ID associated with this recording. */
  callId: string
  /** Call direction - ingress (incoming) or egress (outgoing). */
  direction: 'ingress' | 'egress'
  /** Category of the recording. */
  category: 'webrtc'
  /** When the recording started. */
  startTimestamp: string
  /** Offset in seconds from the call start when recording began. */
  startOffset: number
  /** Size of the recording file in bytes. */
  size: number
  /** Transcribed text of the recording. */
  transcript: string
  /** Language code of the transcription. */
  transcriptLang: string
}
export type SchemaRecording = SchemaRecordingListItem & {
  /** Duration of the recording in seconds. */
  duration: number
  /** Caller ID. */
  callerid?: string
  /** Call destination. */
  to?: string
  /** Contact ID associated with this call. */
  contactId: number
  /** Whether the associated contact has been deleted. */
  contactDeleted: boolean
  /** Contact's first name. */
  firstName?: string
  /** Contact's last name. */
  lastName?: string
  /** Contact's full phone number. */
  fullPhoneNumber?: string
  /** Campaign ID associated with this call. */
  campaignId: number
  /** Name of the campaign. */
  campaignName: string
  /** Username of the user who made the call. */
  userUsername: string
  /** First name of the user who made the call. */
  userFirstName: string
  /** Last name of the user who made the call. */
  userLastName: string
  /** Two-letter ISO country code for the call. */
  countryIso: string
  /** When the call started. */
  callStart: string
  /** Total duration of the call in seconds. */
  callDuration: number
}
export type SchemaCampaignQuota = {
  /** Unique engageSPARK ID of the quota. */
  quotaId: string
  /** Conditions for when this quota should be applied. This is a JSON logic expression. When null, the quota applies to all contacts. */
  conditions: any[] | null
  /** Name of the quota. */
  quotaName: string
  /** The target/goal number for this quota. */
  quotaGoal: number
  /** Number of times this quota has been used. */
  quotaUsed: number
  /** Whether the quota goal has been reached. */
  quotaHit: boolean
}
export type SchemaReportfield = {
  /** Unique identifier for the report field (lowercase alphanumeric only). */
  id: string
  /** Human-readable name for the report field. */
  name: string
  /** Format validation for the report field value. Determines what values are acceptable.
    - "" (empty string): No validation. Accepts any string value.
    - "number": Validates that the value is a valid number (integer or float, including scientific notation).
    - "filename": Validates that the value is a valid filename (no slashes or whitespace)
     */
  format?: '' | 'number' | 'filename'
  /** How the report field value should be displayed in reports.
    - "" (empty string): Default display. Shows the raw value.
    - "link": Displays the value as a clickable download link, valid for 3 weeks. The value should be a valid filename that exists in storage.
    - "dollar": Formats numeric values with a dollar sign prefix (e.g., "3.14" becomes "$3.14").
    - "embed": Embeds the value as an image in the report. The value should be a valid filename that exists in storage.
    - "none": The field it not shown in the report. It cannot be explicitly listed either.
     */
  display?: '' | 'link' | 'dollar' | 'embed' | 'none'
}
export type SchemaCampaign = {
  /** Unique engageSPARK ID of the campaign. */
  id: number
  /** Same as the .id field. */
  engagementId: number
  /** Type of the campaign. */
  template: string
  /** Friendly name of the campaign. */
  name: string
  /** Launch time. FIXME */
  launch: object
  /** What .open will be set to on launch. "open" campaigns can get new subscriptions. */
  launchOpen: boolean
  /** Contacts which will be subscribed on launch. FIXME */
  contacts: object
  /** Campaign configuration. */
  variables: object
  /** Place for the UI to store data. */
  uiStore: object
  /** Times calls will go out. Only relevant for campaigns which make calls. FIXME */
  callWindow: object
  /** Maximum number of times we try to contact someone.

    Special values: -2 means use the .callAgainCustom field, -1 means use the system default, 0 means disable.

    Only relevant for campaigns which make calls. */
  callAgainMax: number
  /** Custom schedule for call retries. Only relevant for campaigns which make calls. FIXME */
  callAgainCustom?: object[]
  /** Maximum number of times we try to reconnect dropped calls.

    Special values: -1 means use the system default, 0 means disable.

    Only relevant for campaigns which make calls. */
  reconnectMax: number
  /** If false: only reconnect if the user was connected for at least 10 seconds. If true: only reconnect if they reached a next part. Only relevant for campaigns which make calls and have reconnect enabled. */
  reconnectOnProgress: boolean
  /** Time this campaign was created. */
  createdAt: string
  /** Published? A campaign can be "unpublished" until it's "launched". */
  published: boolean
  /** If true contacts can be subscribed to this campaign. */
  open: boolean
  /** This is the time a published, but not yet launched, campaign will be launched. Or was, if the campaign is already launched. */
  autoLaunchAt: string
  /** A launched campaign is or has been running. It'll stay true even when a campaign is aborted. */
  launched: boolean
  /** Time this campaign was launched (only valid if .launched is true). */
  launchedAt: string
  /** Campaign is stopped. */
  aborted: boolean
  /** Time this campaign was aborted (only valid if .aborted is true). */
  abortedAt: string
  /** Archived campaigns aren't shown in the UI by default. That's all this do, it has no effect on the launch or aborted stage. */
  archived: boolean
  /** Total number of subscriptions. This should be runsInProgress + runsInProgress + runsDone. */
  runs: number
  /** Total number of subscriptions which have started and are not done yet. */
  runsInProgress: number
  /** Total number of subscriptions which have finished. */
  runsDone: number
  /** Total number of subscriptions which got unsubscribed. They are done. */
  runsUnsubbed: number
  /** Total number of subscriptions which are done, but with a (fatal) error. */
  runsError: number
  /** Total number of subscriptions which had a (non-fatal) error, such as an undelivered SMS. They might be done or not. */
  runsWithFailures: number
  /** Is Answering Machine Detection enabled? Only relevant for campaign with make voice calls. */
  amd: boolean
  /** Version of the campaign, incremented whenever something is edited. Starts at 1. */
  version: number
  /** Client reference for this campaign. */
  clientRef: string
  /** If relevant for this campaign type, the number of parts in this campaign. */
  statParts: number
  /** If relevant for this campaign type, the number of questions in this campaign. */
  statQuestions: number
  /** Possible statuses, only relevant for CATI campaigns. */
  userStatuses: string[]
  /** Files used in this campaign. */
  files: object
  /** Quotas associated with this campaign. */
  quotas: SchemaCampaignQuota[]
  /** Report field definitions for this campaign. Each report field can store custom data per subscription. */
  reportFields: SchemaReportfield[]
}
export type PropertiesDaysofweek = {
  monday?: boolean
  tuesday?: boolean
  wednesday?: boolean
  thursday?: boolean
  friday?: boolean
  saturday?: boolean
  sunday?: boolean
}
export type SchemaSubDelay = {
  /** Time unit for the subscription delay. */
  unit?: '' | 'second' | 'minute' | 'hour' | 'day' | 'week' | 'month' | 'at'
  /** The number of units. For example, if you set `unit` to `"minute"`, then a `value` of `5` delays the subscription by five minutes. */
  value?: number
  /** Legacy version of `daysOfWeek`, see `daysOfWeek`. */
  dayOfWeek?: 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'
  /** Optional day of the week when the subscription should activate, only relevant for 'week' unit. */
  daysOfWeek?: PropertiesDaysofweek
  /** Optional specific time of day when the subscription should activate, required if unit is 'day' or 'week'. */
  time?: string
  /** Optional timezone for the specified 'time', defaults to UTC if not provided. */
  timezone?: string
  /** Optional two-letter ISO country code, used to determine the timezone if `timezone` is not set. */
  country?: string
  /** Specific date and time when the subscription should start, required if unit is 'at'. If set, overrides all other fields. */
  at?: string
  /** Relative to what message in the campaign. */
  relative?: '' | 'previous' | 'initial'
}
export type PropertiesContact = {
  firstName?: string
  lastName?: string
  /** Sets the language field. Used for campaigns that support multiple languages. */
  language?: string
  /** List of integer group IDs this contact should be added to. */
  groups?: (number | string)[]
  /** Update custom fields as identified by their IDs.

    Empty values are valid, and will remove the current value. Only fields that are provided are updated. */
  customFields?: {
    [key: string]: string
  }
  /** An alterative way to set Custom fields. The keys of the objects are the names of the custom fields. We'll use the existing group ID, or create a new one if it doesn't exist.
    Empty values are valid, and will remove the current value. Only fields that are provided are updated.
    - names are compared case in-sensitive (so if you add "Gender", it'll re-use an existing column "gender").
    - if there are multiple possible matches, then we take the oldest existing custom field.
    - if the same custom field is used in customFields and customFieldsByName, then the value in customFieldsByName wins.
    - if the same custom field is given multiple times in customFieldsByName then it's not defined which one wins (`{"color": "green", "COLOR": "red"}`. The custom field color can now be either red or green). */
  customFieldsByName?: object
}
export type SchemaReportfieldValue = {
  /** The ID of the report field */
  reportFieldId: string
  /** The value of the report field */
  value: string
}
export type SchemaCondition = (string | number | any)[][]
export type SchemaSubContacts = {
  /** When true, all contacts in the organization are selected (except those excluded). */
  allContactsAreSelected?: boolean
  /** Array of specific contact IDs to include. */
  includedContactIds?: number[]
  /** Search term to find contacts by name, phone number, or email. */
  search?: string
  /** Filter contacts by phone number. */
  phoneNumber?: string
  /** Array of group IDs to include all contacts from those groups. */
  includedGroupIds?: number[]
  /** Array of contact IDs to exclude from the selection. */
  excludedContactIds?: number[]
  conditions?: SchemaCondition
  /** Include contacts that are marked for auto-deletion. */
  noautodelete?: boolean
}
export type SchemaCampaignSummary = {
  /** Total cost in USD * 1m. */
  costMicro: number
  /** Total cost in USD. */
  costHuman: string
  overallMessageStats: {
    /** Total number of SMS messages. */
    total: number
    /** Total cost in USD * 1m. */
    costMicro: number
    /** Total cost in USD. */
    costHuman: string
    /** Number of total SMS sent. */
    totalEgress: number
    /** Number of SMS that failed to be delivered to the telco. */
    deliveredToTelcoFailed: number
    /** Number of SMS with an unknown delivery status. */
    deliveredToPhoneUnknown: number
    /** Number of SMS that failed to be delivered to the target device. */
    deliveredToPhoneFailed: number
    /** Number of SMS that were successfully delivered to the target device. */
    deliveredToPhoneConfirmed: number
    /** Number of SMS still being processed. */
    inProgress: number
    /** Number of SMS received. */
    totalIngress: number
  }
  overallWhatsappStats: {
    /** Total number of WhatsApp messages. */
    total: number
    /** Total cost in USD * 1m. */
    costMicro: number
    /** Total cost in USD. */
    costHuman: string
    /** Number of total WhatsApp messages sent. */
    totalEgress: number
    /** Number of successful WhatsApp messages sent. */
    success: number
    /** Number of WhatsApp messages still being processed. */
    inProgress: number
    /** Number of failed WhatsApp messages sent. */
    failed: number
    /** Number of WhatsApp messages received. */
    totalIngress: number
  }
  overallVoiceStats: {
    /** Total number of voice calls. */
    total: number
    /** Total cost in USD * 1m. */
    costMicro: number
    /** Total cost in USD. */
    costHuman: string
    /** Number of total outgoing voice calls. */
    totalEgress: number
    /** Number of redialed voice calls. */
    callAgain: number
    /** Number of voice calls that failed to ring. */
    failedToRing: number
    /** Number of voice calls not answered. */
    notAnswered: number
    /** Number of voice calls answered. */
    answered: number
    /** Total duration of all voice calls in seconds. */
    seconds: number
    /** Number of inbound voice calls. */
    totalIngress: number
    /** Number of calls detected as answering machines. */
    amdDetected: number
    /** Average seconds of answered calls. */
    answeredSecondsAvg: number
    /** Median seconds of answered calls. */
    answeredSecondsMedian: number
  }
  overallAirtimeStats: {
    /** Total number of airtime topups. */
    total: number
    /** Number of successful airtime topups. */
    success: number
    /** Total cost in USD * 1m. */
    costMicro: number
    /** Total cost in USD. */
    costHuman: string
  }
  partStats: {
    /** Part ID in the campaign definition. */
    id: string
    /** Part name. */
    name: string
    /** Part description. */
    description: string
    /** Total cost in USD * 1m for this part. */
    costMicro: number
    message?: {
      total: number
      costMicro: number
      costHuman: string
      totalEgress: number
      deliveredToTelcoFailed: number
      deliveredToPhoneUnknown: number
      deliveredToPhoneFailed: number
      deliveredToPhoneConfirmed: number
      inProgress: number
      totalIngress: number
    }
    whatsapp?: {
      total: number
      costMicro: number
      costHuman: string
      totalEgress: number
      success: number
      inProgress: number
      failed: number
      totalIngress: number
    }
    voice?: {
      total: number
      costMicro: number
      costHuman: string
      totalEgress: number
      callAgain: number
      failedToRing: number
      notAnswered: number
      answered: number
      seconds: number
      totalIngress: number
      amdDetected: number
      answeredSecondsAvg: number
      answeredSecondsMedian: number
    }
    airtime?: {
      total: number
      success: number
      costMicro: number
      costHuman: string
    }
    replies?: {
      responses: number
      valid: number
      invalid: number
      timeout: number
      /** Count for every given answer, cleaned version. */
      answers: {
        [key: string]: number
      }
      /** Label mapping for answers. */
      answerLabels: {
        [key: string]: string
      }
    }
  }[]
}
export type SchemaWaitreason =
  | ''
  | 'actions'
  | 'ai'
  | 'api_call'
  | 'call'
  | 'callagain'
  | 'finalizing'
  | 'next_part'
  | 'reconnect'
  | 'reply_chat'
  | 'reply_sms'
  | 'reply_whatsapp'
  | 'send_whatsapp'
  | 'topup'
  | 'user'
export type SchemaCampaignSubscriptions = {
  /** Total number of subscriptions. */
  total: number
  /** Array of subscription objects. */
  runs: {
    /** Unique subscription ID. */
    id: number
    /** ID of the contact this subscription belongs to. */
    contactId: number
    /** When the subscription started. */
    start: string
    /** Whether the subscription is currently in progress. */
    inProgress: boolean
    /** Whether the subscription has completed. */
    done: boolean
    /** Whether the subscription has been unsubscribed. */
    unsubbed: boolean
    /** Whether the subscription encountered an error. */
    error: boolean
    /** Error message if the subscription failed. */
    errorMessage: string
    /** User-defined status for the subscription. */
    userStatus: string
    /** Whether the contact has been deleted. */
    contactDeleted: boolean
    /** First name of the contact (if permissions allow). */
    firstName?: string
    /** Last name of the contact (if permissions allow). */
    lastName?: string
    /** Full phone number of the contact (if permissions allow). */
    fullPhoneNumber?: string
    waitReason: SchemaWaitreason
    /** Report field values for this subscription. */
    reportFields?: SchemaReportfieldValue[]
  }[]
}
export type SchemaSubstatus = {
  /** Total number of subscriptions for this contact. */
  totalCount: number
  /** Number of subscriptions currently in progress. */
  inProgressCount: number
  /** Number of subscriptions that have completed. */
  doneCount: number
  /** Number of subscriptions that have been unsubscribed */
  unsubbedCount: number
  /** Number of subscriptions that encountered errors. */
  errorCount: number
  /** Number of subscriptions that had failures. */
  withFailuresCount: number
  /** ID of the active subscription, if any. */
  activeId: number
  /** ID of the last subscription processed. */
  lastId?: number
}
export type SchemaContact = {
  /** Unique engageSPARK ID of the contact. */
  id?: number
  /** International phone number of the contact, without leading "+". */
  fullPhoneNumber?: string
  /** First name of the contact. */
  firstName?: string
  /** Last name of the contact. */
  lastName?: string
  /** Language of the contact. */
  language?: string
  /** Group IDs this contact is in. The IDs can be groups or segments. */
  groups?: number[]
  /** All the custom field values set. */
  customFields?: {
    [key: string]: string
  }
  /** Name of the carrier. */
  carrier?: string
  /** Time this contact was created. */
  createdAt?: string
  /** Last time this contact was updated, either the contact itself, or a custom field, or groups have changed. */
  updatedAt?: string
  /** Last time this contact was used. */
  lastUseAt?: string
  /** If set, this contact will not be deleted by the organization's contact autodelete. */
  noAutodelete?: boolean
  /** If true, this contact has a whatsapp business user ID set. */
  withBsuid?: boolean
  /** Whether the contact's phone number is invalid */
  invalid?: boolean
  subscription?: SchemaSubstatus
}
export type SchemaCampaignSubscription = {
  /** Unique subscription ID. */
  id: number
  /** Current state of the subscription as JSON. */
  state: object
  /** When the subscription started. */
  start: string
  /** Whether the subscription is currently in progress. */
  inProgress: boolean
  /** Whether the subscription has completed. */
  done: boolean
  /** Whether the subscription has been unsubscribed. */
  unsubbed: boolean
  /** Whether the subscription encountered an error. */
  error: boolean
  /** Error message if the subscription failed. */
  errorMessage: string
  waitReason: SchemaWaitreason
  contact?: SchemaContact
  /** Summary information about the campaign this subscription belongs to. */
  campaign: {
    /** Campaign ID. */
    id: number
    /** Campaign name. */
    name: string
    /** Campaign template type. */
    template: string
    /** List of user-defined statuses available for this campaign. */
    userStatuses: string[]
  }
  /** Report field values for this subscription. */
  reportFields?: SchemaReportfieldValue[]
}
export type SchemaCustomfield = {
  /** Unique engageSPARK ID of the custom field. */
  id: number
  /** Name of the custom field. */
  name: string
  /** You have access to see the values in this custom field (which can have PII). */
  access: boolean
}
export type SchemaDatatable = {
  /** ID of the datatable, use in the URLS */
  id: string
  /** Nicer name of the datatable. */
  name: string
  /** When this datatable was created */
  created: string
  /** The columns */
  columns: {
    /** ID of the column */
    id?: string
    /** Nicer of the column */
    name?: string
  }[]
}
export type SchemaDatatableRow = {
  /** ID of the row, use in the URLs, likely a UUID */
  id: string
  /** When this row was created */
  created: string
  /** When this row was last updated */
  updated: string
  /** key/value of the columns */
  values: object
}
export type Orgid = number
export type SchemaDidsItem = {
  /** Phone number ID */
  id: number
  orgId: Orgid
  /** Name of the phone number */
  name: string
  /** Date and time when the phone number was created */
  create: string
  /** Phone number */
  phoneNumber: string
  /** Keyword associated with the phone number */
  keyword: string
  /** Inbound call campaign ID, only voice-capable numbers have this */
  inboundCallCampId?: number
  /** Country code */
  countryCode: string
  /** Number of SMS hooks associated with the phone number */
  hookCount: number
  /** Number of call hooks associated with the phone number */
  callHookCount: number
  /** Number of WhatsApp hooks associated with the phone number */
  whatsappHookCount: number
  /** Is this an international phone number? */
  international: boolean
  /** Is this phone number registered with WhatsApp as a senderID? */
  whatsAppRegistered: boolean
  /** If this is true, the users can use this number to complete the whole WhatsApp Business SenderID registration process with Meta. */
  whatsAppMetaOtp?: boolean
  /** Is this phone number capable of sending SMS? */
  sms: boolean
  /** Is this phone number capable of sending WhatsApp messages? */
  whatsApp: boolean
  /** Is this phone number capable of making voice calls? */
  voice: boolean
}
export type SchemaActionApi = {
  makeAPIRequest: {
    /** Array of key-value pairs to send as headers. */
    headers: {
      key: string
      value: string
    }[]
    /** HTTP method to use. */
    method: string
    /** Payload to send. */
    payload: string
    /** URL to send the request to. */
    url: string
  }
}
export type SchemaActionFinishFlow = {
  finishFlow: object
}
export type SchemaActionHangup = {
  hangup: object
}
export type SchemaActionJump = {
  jump: {
    /** the id of the part to jump to */
    nextPart: string
  }
}
export type SchemaActionPickup = {
  pickUp: {
    /** ID of the campaign to pick up the call to. */
    campId: number
  }
}
export type SchemaAudioContent = {
  /** The URL of the audio file to be played. */
  playfile?: string
  /** The text to be spoken. */
  say?: string
  /** The voice to be used for the text-to-speech. */
  voice?: string
}
export type SchemaActionPlayAudio = {
  play: SchemaAudioContent
}
export type SchemaActionReplayQuestion = {
  replayQuestion: object
}
export type SchemaActionResendQuestion = {
  resendQuestion: object
}
export type SchemaActionSendEmail = {
  sendEmail: {
    from: string
    to: string
    toMultiple: string[]
    subject: string
    message: string
  }
}
export type SchemaSmsContent = {
  /** The text of the SMS message. */
  text: string
}
export type SchemaSmsTranslations = {
  translations: {
    [key: string]: SchemaSmsContent
  }
}
export type SchemaActionSendSmsPhone = {
  sendSMSToPhoneNumbers: SchemaSmsContent &
    SchemaSmsTranslations & {
      /** Phone numbers to send the SMS to. */
      phoneNumber: string[]
      /** Sender ID to use. */
      senderId: string
      /** Use the sender ID of the campaign. */
      useCampaignSenderId: string
    }
}
export type SchemaActionSendSms = {
  sendSMS: SchemaSmsContent &
    SchemaSmsTranslations & {
      /** Sender ID to use. */
      senderId: string
      /** Use the sender ID of the campaign. */
      useCampaignSenderId: string
    }
}
export type SchemaWhatsappContent = {
  /** The text of the WhatsApp message. */
  text?: string
  /** The URL of the audio file to be played. */
  audio?: string
  /** The URL of the document to be sent. */
  document?: string
  /** The URL of the image to be sent. */
  image?: string
  /** The URL of the video to be sent. */
  video?: string
}
export type SchemaWhatsappTranslations = {
  translations: {
    [key: string]: SchemaWhatsappContent
  }
}
export type SchemaActionSendWhatsapp = {
  sendWhatsapp: SchemaWhatsappContent &
    SchemaWhatsappTranslations & {
      /** Sender ID to use. */
      senderId: string
      /** Use the sender ID of the campaign. */
      useCampaignSenderId: string
      /** Register this message as a WhatsApp template. */
      registerTemplate: boolean
    }
}
export type SchemaActionSetreportfield = {
  setReportField: {
    /** The ID of the report field to set (pztemplate supported) */
    reportFieldId: string
    /** The value to set (pztemplate supported) */
    value: string
  }
}
export type SchemaActionSubscribe = {
  subscribeToCampaign: {
    /** Campaign ID to subscribe to. */
    campaignId: number
    /** Name of the campaign to subscribe to, only used by the UI */
    campaignName: string
    /** Should a contact be resubscribed if it has a previous, already finished subscription? */
    allowResubscribe?: boolean
    delay?: SchemaSubDelay
    /** Campaign-specific arguments passed to the campaign. */
    args?: {
      [key: string]: any
    }
    /** Report field values to be set for this subscription. Both reportFieldId and value support pztemplate expansion. */
    reportFields?: SchemaReportfieldValue[]
  }
}
export type SchemaActionTopup = {
  topup: {
    /** maxAmount is used if maxAmountTemplated is an empty string (before expanding the templates). */
    maxAmount: string
    /** maxAmountTemplated is used if it's not empty. Templates can be used, but the result should be a float. */
    maxAmountTemplated: string
    /** Desired amount to top up, templated. */
    desiredAmountTemplated: string
  }
}
export type SchemaActionTransfer = {
  transfer: {
    /** Phone number to transfer the call to. */
    to: string
  }
}
export type SchemaActionUnsubscribeAll = {
  unsubscribeAll: object
}
export type SchemaActionUnsubscribe = {
  unsubscribeCampaign: {
    /** Campaign ID to unsubscribe from. */
    campId: number
    /** Unsubscribe from the current campaign. */
    current: boolean
  }
}
export type SchemaActionUpdateContact = {
  updateContact: {
    /** - field is either a contact field:
          - contact.firstName
          - contact.lastName
          - contact.language
          - contact.dialingCode
          - contact.phoneNumber
          - contact.fullPhoneNumber
          - contact.email
          - or it's customfields.XXX, in which case it's the ID of a custom field.
          - call.result
          - call.anwer - answer time of a call (empty if not answered)
          - call.duration - call time in seconds (empty it not answered) */
    field: object
    /** - value is one of:
          - answer - the "label" answer given to a question
          - response - the raw response given to a question
          - constant - use the constant field
          - message - the sms if this action is attached to an incoming sms DID hook */
    value: string
    /** used if value is constant. Templating supported */
    constant: string
  }
}
export type SchemaAction = {
  /** Unique ID of the action. */
  id: string
} & (
  | SchemaActionApi
  | SchemaActionFinishFlow
  | SchemaActionHangup
  | SchemaActionJump
  | SchemaActionPickup
  | SchemaActionPlayAudio
  | SchemaActionReplayQuestion
  | SchemaActionResendQuestion
  | SchemaActionSendEmail
  | SchemaActionSendSmsPhone
  | SchemaActionSendSms
  | SchemaActionSendWhatsapp
  | SchemaActionSetreportfield
  | SchemaActionSubscribe
  | SchemaActionTopup
  | SchemaActionTransfer
  | SchemaActionUnsubscribeAll
  | SchemaActionUnsubscribe
  | SchemaActionUpdateContact
)
export type SchemaInboundHookPayload = {
  /** Conditions for the hook to trigger. For call hooks, this allows filtering incoming calls. */
  conditions: {
    /** List of conditions that must be met for the hook to trigger. Uses the same condition syntax as campaigns. */
    conditions?: null | SchemaCondition[]
    /** For SMS/WhatsApp hooks: if true, only trigger on unexpected messages (not responses to sent messages). Not applicable for call hooks. */
    unexpected?: boolean
  }
  /** Actions to execute when the hook triggers.
    For inbound call hooks:
    - Actions are processed _before_ we pick up the call - We process hooks (if their conditions match) until we find one with a "pickUp" action - We don't process hooks after that one (but we finish the hook) - All actions are still executed _before_ we pick up, even if they come _after_ the "pickUp" action - If there are multiple pickUp actions in a single hook we execute the first */
  actions: SchemaAction[]
  /** Label of the inbound hook */
  label: string
}
export type SchemaInboundHook = SchemaInboundHookPayload & {
  /** Unique ID of the inbound hook. */
  id: number
}
export type SchemaExport = {
  /** Unique export id. */
  id: number
  /** Time the export was created. */
  created: string
  /** The type of the export. */
  function: 'aicamp' | 'campreport' | 'orgspend' | 'smsreport'
  /** The status of the export. */
  status: 'queued' | 'inprogress' | 'failed' | 'ready'
  /** Time the export was finished, if applicable. */
  finished?: string
  files?: {
    /** The name of the file. */
    filename: string
    /** The mime type of the file. */
    contentType: string
    /** The size of the file in bytes. */
    size: number
    /** The hash of the file. */
    sha256: string
    /** The number of rows in the file. */
    rowCount: number
  }[]
}
export type SchemaFile = {
  /** The name of the file. */
  filename: string
  /** The title of the file. */
  title: string
  /** The category of the file given on upload. */
  category: string
  /** Transcript previously set. This field isn't set automatically. */
  transcript: string
  /** The size of the file in bytes. */
  size: number
  /** The SHA1 checksum of the file. */
  sha1: string
  /** The date and time when the file was uploaded. */
  upload: string
  /** We automatically generate a thumbnail for the file if the file is a video file and set this property to true, which is available as /thumb/<filename>. */
  thumb: boolean
}
export type SchemaGroupType = 'NORMAL' | 'SMART'
export type SchemaGroup = {
  /** Unique engageSPARK ID of the group. */
  id: number
  /** Name of the group. Max 100 characters. */
  name: string
  /** Description of the group. */
  description: string
  type: SchemaGroupType
  /** Number of contacts in the group. */
  numberOfContacts: number
  /** Time this group was created. */
  createdAt: string
  conditions: null | SchemaCondition[]
  /** If set, the group is being recounted. Read-only. */
  recounting: boolean
  /** Do not automatically delete the contacts of this group if contact autodeletion is enabled for this org. You can still delete them manually. */
  noAutodelete: boolean
}
export type SchemaContactsSelection = {
  /** If true, all contacts are selected, possibly excluding some via excludedContactIds. Only excludedContactIds can be given. Else no contacts are selected by default, but they are added via (includedContactIds OR search OR phoneNumber) AND includedGroupIds. */
  allContactsAreSelected?: boolean
  /** List of contact IDs that are included in the selection. */
  includedContactIds?: number[]
  /** Search string to filter contacts by, full text search. */
  search?: string
  /** Phone number to filter contacts by, needs to match full phone number. */
  phoneNumber?: string
  /** List of group IDs that are included in the selection. */
  includedGroupIds?: number[]
  /** Array of contact IDs to exclude from the selection. */
  excludedContactIds?: number[]
  /** Condition work on whatever the rest of the block selects, and only leaves contacts which match. So if you want to run them on all contacts, you need to set allContactsAreSelected.. */
  conditions?: SchemaCondition
}
export type SchemaOrgInvite = {
  /** Unique identifier for the invite */
  inviteId: number
  /** Email address of the invited user */
  email: string
  /** First name of the invited user */
  firstName: string
  /** Last name of the invited user */
  lastName: string
  /** Role the user will have in the organization */
  role: 'manager' | 'collaborator' | 'cati_agent'
  /** When the invitation was created */
  created: string
}
export type SchemaInvoice = {
  /** The issue date of the invoice in YYYY-MM-DD format. */
  date: string
  /** The year of the invoice. */
  year: number
  /** The month of the invoice. */
  month: number
  /** Invoice PDF filename. */
  pdf: string
  /** Invoice XLSX filename. */
  xlsx: string
}
export type SchemaOrg = {
  /** Name of the organization */
  name: string
  /** Website of the organization */
  website: string
  /** Phone number of the organization */
  phone: string
  /** Address of the organization */
  address: string
  /** Country of the organization */
  country: string
  /** Location of the organization */
  location: string
  /** The minimum amount of money spent that triggers a notification to be sent to the organization. A null value means no notification will be sent. */
  spendNotification: number
  /** The minimum balance that triggers a notification to be sent to the organization. */
  balanceNotification: number
  /** The maximum amount of money that can be spent by the organization in a day. A null value means no limit. */
  maxDailySpend: number
  /** If enabled, automatically delete contacts N days after their last use or update. */
  contactsAutodelete?: boolean
  /** Number of days for .contactsAutodelete . */
  contactsAutodeleteDays?: number
  /** Does every user need to setup 2FA? */
  totpRequired?: boolean
  /** Total number of contacts in the organization. */
  contacts?: number
  /** Total number of (non-archived) campaigns in the organization. */
  campaigns?: number
}
export type SchemaOrgPlan = {
  /** Unique identifier for the plan */
  planId: number
  /** Display name of the plan */
  label: string
  /** Detailed description of the plan */
  description: string
  /** Monthly price of the plan */
  priceMonthly: string
  /** Yearly price of the plan */
  priceYearly: string
  /** Billing frequency */
  billing: string
  /** Start date of the plan subscription */
  start: string
  /** Date of the most recent billing */
  lastBillingDate: string
  /** Date of the next scheduled billing */
  nextBillingDate: string
  /** Whether the plan has been canceled */
  canceled: boolean
  /** End date of the subscription (if applicable) */
  end: string | null
  /** Current price being charged */
  price: string
  /** Number of days remaining in the trial period */
  trialDaysLeft: number
  /** Number of users included in the plan */
  usersIncluded: number
  /** Current number of users */
  usersNow: number
  /** Number of pending invitations */
  openInvites: number
  /** Maximum number of contacts that can be stored */
  storedContactsMax: number
  /** Current number of stored contacts */
  storedContactsNow: number
  /** Countries included in the plan */
  countriesIncluded: string
  /** Whether there is a future plan change scheduled */
  future: boolean
  /** ID of the future plan (if applicable) */
  futurePlanId: number
  /** Billing frequency of the future plan */
  futureBilling: string
  /** Start date of the future plan */
  futureStart: string
  /** Display name of the future plan */
  futureLabel: string
}
export type SchemaBlock = {
  /** Unique engageSPARK ID of the phone number block. */
  id: string
  /** International phone number of the block, without leading "+". */
  phoneNumber: string
  /** When this block was added */
  created: string
  /** UserID who added this. Can be 0 if Customer Support added this block. */
  userId: number
  /** Given reason. */
  why: string
  /** ISO code of the country the phone number is in. */
  countryIso: string
}
export type SchemaPurchase = {
  /** The unique identifier of the purchase. */
  id: number
  /** The amount spent. */
  amount: string
  /** The code for the transaction type of the purchase. */
  transCode:
    | 'purchase_of_funds'
    | 'purchase_of_funds_via_credit_card'
    | 'purchase_of_funds_via_paypal'
    | 'purchase_of_funds_via_bank_wire'
    | 'purchase_of_funds_via_western_union'
    | 'purchase_of_funds_via_cash'
    | 'purchase_of_funds_via_check'
  /** The date and time the purchase was created. */
  created: string
}
export type SchemaSenderid = {
  /** Phone number in E.164 format without the leading +. */
  phonenumber?: string
  /** Name of the phone number. */
  name?: string
  /** Alphanumeric sender ID or caller ID. */
  sender?: string
}
export type SchemaSms = {
  /** engageSPARK message ID. Will be unique. */
  messageId: string
  /** The message ID of the original message with the same clientDedup. Only present in error responses when clientDedup conflicts. */
  dedupMessageId: string
  /** Number of SMSs used to send the message (estimate). */
  estimateParts: number
  /** Price per part, in millionths of a dollar. */
  estimateMicro: number
  /** Total estimated cost, in USD, rounded down to cents. */
  estimate: string
  /** If there are problems with the telco we'll try to deliver the message until this timestamp. */
  deliveryDeadline: string
  /** Full phone number of the recipient. Including country code, no leading "+". */
  to: string
  /** The message as we send it. */
  message: string
  /** Echo of the "clientDedup" field we received in the request. */
  clientDedup: string
  /** Echo of the "clientPushURL" field we received in the request. */
  clientPushURL: string
  /** Echo of the "clientRef" field we received in the request. */
  clientRef: string
  /** ID of the contact. */
  contactId: number
  /** Error message, if any. */
  error: string
  /** Error code, if any. */
  errorCode?: string
}
export type SchemaModelSms = {
  /** engageSPARK message ID. Will be unique. */
  id?: string
  /** Egress or Ingress message */
  direction?: 'egress' | 'ingress'
  /** Time the messages got created. Delivery (if any) will be after this. */
  created?: string
  /** Sender of the message. Won't be present if the user doesn't have permissions to see this field. */
  sender?: string
  /** Sender of the message. Won't be present if the user doesn't have permissions to see this field. */
  recipient?: string
  /** engageSPARK contact ID. */
  contactId?: number
  /** The charged price in micro USD per part of the SMS. */
  pricePerPart?: number
  /** If not true engageSPARK will try more deliveries still. */
  done?: boolean
  /** Number of parts a successful SMS was made of. */
  successPartCount?: number
  /** Time the message got sent. */
  successT?: string
  /** The message as we (tried to) send. Personalization, if any, will be expanded. */
  message?: string
  /** Description what went wrong when passing the SMS to the telco for delivery.
    This is the error you want to look at, if `deliveredToTelco` is `false`.
    Note that this field can be empty while the Delivery Receipt does indicate a problem. */
  error?: string
  /** Delivery Receipt error, if any.
    This is set, if `deliveredToTelco` is `true` and `deliveredToPhone` is `failed`.
    Examples of possible errors:
    - anti-spam filter
    - blocked
    - contact absent
    - contact absent - permanent
    - contact absent - temporary
    - contact error
    - contact phone issue
    - expired
    - message error
    - network error
    - no route
    - not mobile number
    - opted out of promotional messaging
    - unknown
    - unreachable */
  deliveryError?: string
  /** Was this SMS successfully delivered to our telco partner?

    True if the message is successfully delivered to the telco partner. False if there was an error or while the message is still being delivered.

    Note that this is the first step. It does not mean it has reached the handset. */
  deliveredToTelco?: boolean
  /** The Delivery Receipt status of this SMS.

    Not all telcos support delivery receipts and they are not always reliable. This varies per telco per country. Contact us to know if delivery receipts are available in your program country, and how reliable they can be expected to be.

    - unknown – means we haven’t received a delivery receipt from the telecom. This can happen either when (a) deliveredToTelco is `false` OR (b) deliveredToTelco is `true` but the vendor hasn’t sent us the delivery receipt, yet.
    - confirmed – means we received the delivery receipt from the telecom and it says that, yes, the SMS was delivered.
    - failed – means we received the delivery receipt from the telecom and it says the SMS could not be delivered. */
  deliveredToPhone?: 'unknown' | 'confirmed' | 'failed'
  /** The value set in the "clientRef" value in the original "send SMS" API call. engageSPARK doesn't do anything with this value, besides returning it here. */
  client_ref?: string
  /** The charged price in micro USD in total. In case of refunds this can be 0. */
  chargedMicro?: number
  /** The charged price in USD as string. Has 2 digits, but 6 if there charge uses amounts smaller than cents. */
  chargedHuman?: string
}
export type SchemaSnippet = {
  id: number
  category: string
  snippet: {
    [key: string]: any
  }
  userId?: number
  referencedFiles?: string[]
  referencedCampaigns?: number[]
  referencedContacts?: number[]
  /** This signals that the snippet references a campaign / contact / file that is no longer valid. */
  valid: boolean
  files: SchemaFile[]
}
export type SchemaSubscription = {
  /** Unique subscription ID. */
  subId: number
  /** ID of the contact this subscription belongs to. */
  contactId: number
  /** When the subscription started. */
  start: string
  /** Whether the subscription is currently in progress. */
  inProgress: boolean
  /** Whether the subscription has completed. */
  done: boolean
  /** Whether the subscription encountered an error. */
  error: boolean
  /** Error message if the subscription failed. */
  errorMessage?: string
  /** User-defined status for the subscription. */
  userStatus: string
  waitReason: SchemaWaitreason
  /** Full phone number of the contact. */
  contactFullPhoneNumber?: string
  /** Whether the contact's phone number is invalid. */
  contactInvalid: boolean
  /** First name of the contact. */
  contactFirstName?: string
  /** Last name of the contact. */
  contactLastName?: string
  /** Language preference of the contact. */
  contactLanguage?: string
  /** Custom field values for the contact. */
  contactCustomFields: {
    [key: string]: string
  }
  /** Whether the contact has been deleted. */
  contactDeleted: boolean
  /** ID of the campaign this subscription belongs to. */
  campaignId: number
  /** Name of the campaign. */
  campaignName: string
  /** Template type of the campaign. */
  campaignTemplate: string
  /** Report field values for this subscription. */
  reportFields?: SchemaReportfieldValue[]
}
export type SchemaTopup = {
  /** engageSPARK ID */
  id?: string
  /** If false the Top-Up hasn't been successful yet, but is still being retried. */
  done?: boolean
  /** If true we executed the Top-Up successfully. See "error". */
  success?: boolean
  /** Error describing the problem, if any. */
  error?: string
  /** As given in the original request. */
  clientRef?: string
  /** The currency used, e.g. USD. */
  topupCurrency?: string
  /** The amount the user got on their phone. */
  topupReceived?: number
  /** What you got charged. */
  priceCharged?: number
  /** If the user has a contact in the engageSPARK system, this is the first name of that contact. */
  firstName?: string
  /** If the user has a contact in the engageSPARK system, this is the last name of that contact. */
  lastName?: string
}
export type SchemaQuota = {
  /** Unique engageSPARK ID of the quota. */
  id: string
  /** Name of the quota. */
  name: string
  /** The target/goal number for this quota. */
  goal: number
  /** Number of times this quota has been used. */
  used: number
  /** Whether the quota goal has been reached. */
  hit: boolean
  /** Number of campaigns that use this quota. */
  campaigns: number
}
export type SchemaQuotaAdd = {
  /** Name of the quota. */
  name: string
  /** The target/goal number for this quota. */
  goal: number
}
export type SchemaQuotaEdit = {
  /** Name of the quota. */
  name?: string
  /** The target/goal number for this quota. */
  goal?: number
}
export type SchemaUser = {
  /** User ID. */
  id: number
  /** Emailaddress used to log in. */
  username: string
  /** First name of the user. */
  firstName: string
  /** Last name of the user. */
  lastName: string
  /** Phone number of the user. */
  phone: string
  /** Country of the user. */
  country: string
  /** Local timezone of the user. */
  localTimezone: string
  /** Organization ID which is used if the user logs in the site. Note that most API calls need an explicit Organization ID, this field is not used there. */
  activeOrgId: Orgid
  /** ClearFeed hash for the user. */
  clearFeed: string
  /** Whether TOTP (two-factor authentication) is enabled for the user. */
  totpEnabled: boolean
  /** UI store data for the user. */
  uiStore: object
}
export type SchemaPermissions = {
  downloadReport: boolean
  downloadInvoice: boolean
  downloadAuditLog: boolean
  downloadPurchases: boolean
  downloadCallRecordings: boolean
  manageUsers: boolean
  invites: boolean
  getBalance: boolean
  updateBalance: boolean
  updateOrg: boolean
  creditCard: boolean
  plans: boolean
  manageCampaigns: boolean
  contactAutodelete: boolean
  phonenumberBlock: boolean
}
export type SchemaUserOrg = {
  orgId: Orgid
  /** Name of the organization. */
  name: string
  /** Current balance in USD. Can be negative. */
  balance: number
  /** Current balance in USD as a string, with cents. Can be negative. */
  balanceHuman: string
  /** Role of the user in this organization. There are a few predefined rols. */
  role: string
  /** Whether the user receives notifications for this organization. */
  notify: boolean
  permissions: SchemaPermissions
  /** Lists contact fields this user has access to. */
  contactPermissions: {
    firstName: boolean
    lastName: boolean
    fullPhoneNumber: boolean
    language: boolean
  }
  /** Whether TOTP is required for all users in this organization. */
  totpAll: boolean
}
export type SchemaUserWithOrgs = SchemaUser & {
  /** List of organizations the user has access to. */
  orgs: SchemaUserOrg[]
}
export type SchemaAuthtoken = {
  id: number
  key: string
  name: string
  created: string
  /** Optional expiry time for the token */
  expires?: string | null
  active: boolean
  currentlyValid: boolean
}
export type SchemaOrgUser = {
  /** Unique engageSPARK user ID. */
  id: number
  /** Username of the user. */
  username: string
  /** Full name of the user. */
  name: string
  /** If true, the user has enabled two-factor authentication. */
  totp: boolean
  /** Role of the user in the organization. */
  role: 'owner' | 'manager' | 'collaborator' | 'report_viewer' | 'cati_agent' | 'customer_service'
  /** If true, the user will receive email notifications for some events in the organization. */
  notify: boolean
  /** If true, the user has full access to the organization. */
  fullAccess: boolean
  /** If true, the user has read access to all groups.
    This is only set if fullAccess is false. */
  readGroupAll: boolean
  /** List of group IDs the user can see.
    This is only set if fullAccess and readGroupAll are both false. */
  readGroupIds: null | number[]
  /** If true, the user has read access to all custom fields. */
  readCustomFieldAll: boolean
  /** List of custom field IDs the user can see. */
  readCustomFieldIds: null | number[]
  /** List of fields the user can see. */
  readFields: null | string[]
}
export type SchemaModelWhatsapp = {
  /** engageSPARK message ID. Will be unique. */
  id: string
  /** Egress or Ingress message */
  direction: 'egress' | 'ingress'
  /** Time the messages got created. Delivery (if any) will be after this. */
  created: string
  /** Sender of the message. Won't be present if the user doesn't have permissions to see this field. */
  sender?: string
  /** Recipient of the message. Won't be present if the user doesn't have permissions to see this field. */
  recipient?: string
  /** engageSPARK contact ID. */
  contactId: number
  /** If not true engageSPARK will try more deliveries still. */
  done: boolean
  read: boolean
  /** When we got the "read" confirmation. Only relevant if .read is true. */
  readAt: string
  /** Time the message got sent. */
  successT: string
  /** The message as we (tried to) send. Personalization, if any, will be expanded. */
  message: string
  /** Images attached to the message. Load them via /v1/organizations/${ORGID}/files/[filename] */
  imageFiles: string[]
  /** Signed URLs for image files with temporary access tokens. Only present when the sign query parameter is used. These URLs are valid for the duration specified in the sign parameter (max 24 hours). */
  imageUrls?: string[]
  /** Audio files attached to the message. Load them via /v1/organizations/${ORGID}/files/[filename] */
  audioFiles: string[]
  /** Signed URLs for audio files with temporary access tokens. Only present when the sign query parameter is used. These URLs are valid for the duration specified in the sign parameter (max 24 hours). */
  audioUrls?: string[]
  /** Video files attached to the message. Load them via /v1/organizations/${ORGID}/files/[filename] */
  videoFiles: string[]
  /** Signed URLs for video files with temporary access tokens. Only present when the sign query parameter is used. These URLs are valid for the duration specified in the sign parameter (max 24 hours). */
  videoUrls?: string[]
  /** Documents attached to the message. Load them via /v1/organizations/${ORGID}/files/[filename] */
  documentFiles: string[]
  /** Signed URLs for document files with temporary access tokens. Only present when the sign query parameter is used. These URLs are valid for the duration specified in the sign parameter (max 24 hours). */
  documentUrls?: string[]
  /** Full file paths for all attached files (images, audio, video, documents). These will be the same as the imageFiles, audioFiles, videoFiles, and documentFiles combined, but here they are not just the filename, but the full paths to download the files. */
  fullFilePaths: string[]
  /** Set if the contact sends their location. Only supported for inbound messages (direction=ingress). */
  location: {
    latitude?: string
    longitude?: string
    address?: string
    label?: string
  }
  /** object complicated WhatsApp messages. */
  content: object
  /** Description what went wrong when passing the SMS to the telco for delivery.
    This is the error you want to look at, if `deliveredToTelco` is `false`.
    Note that this field can be empty while the Delivery Receipt does indicate a problem. */
  error: string
  /** Delivery Receipt error, if any.
    This is set, if `deliveredToTelco` is `true` and `deliveredToPhone` is `failed`.
    Examples of possible errors:
    - anti-spam filter
    - blocked
    - contact absent
    - contact absent - permanent
    - contact absent - temporary
    - contact error
    - contact phone issue
    - expired
    - message error
    - network error
    - no route
    - not mobile number
    - opted out of promotional messaging
    - unknown
    - unreachable */
  deliveryError: string
  /** The Delivery Receipt status of this SMS.

    Not all telcos support delivery receipts and they are not always reliable. This varies per telco per country. Contact us to know if delivery receipts are available in your program country, and how reliable they can be expected to be.

    - unknown – means we haven’t received a delivery receipt from the telecom. This can happen either when (a) deliveredToTelco is `false` OR (b) deliveredToTelco is `true` but the vendor hasn’t sent us the delivery receipt, yet.
    - confirmed – means we received the delivery receipt from the telecom and it says that, yes, the SMS was delivered.
    - failed – means we received the delivery receipt from the telecom and it says the SMS could not be delivered. */
  deliveredToPhone: 'unknown' | 'confirmed' | 'failed'
  /** The charged price in micro USD in total. In case of refunds this can be 0. */
  charged: number
  /** Whether this WhatsApp message used a registered template. */
  templateRegistered: boolean
  /** The category of the WhatsApp template used at time of sending. */
  templateCategory: string
}
export type SchemaWaContentMessage = {
  /** The text message content. Maximum 1600 characters. */
  message: string
}
export type SchemaWaContentMedia = {
  /** Optional caption or message text accompanying the media. Required for registered templates. Maximum 1600 characters. */
  message?: string
  /** Array of local file paths on our storage system. Paths are relative without tokens or organization IDs (e.g., "cat.jpg"). */
  files: string[]
}
export type SchemaWaContentButtons = {
  /** The main message text displayed above the buttons. Maximum 1024 characters. */
  message: string
  /** Array of interactive buttons. Maximum 3 buttons allowed. */
  buttons: {
    /** Button text displayed to the user. Maximum 20 characters. Must be unique within the button set. */
    title: string
  }[]
}
export type SchemaWaContentList = {
  /** The main message text displayed above the list. Maximum 1024 characters. */
  message: string
  /** Text displayed on the button that opens the list. Maximum 80 characters. */
  button: string
  /** Array of list items. Maximum 10 items allowed. */
  items: {
    /** Unique identifier for the list item. Maximum 200 characters. Must be unique within the list. */
    id: string
    /** The main text of the list item. Maximum 24 characters. */
    item: string
    /** Optional description for the list item. Maximum 72 characters. */
    description?: string
  }[]
}
export type SchemaWaContentLocation = {
  /** Label or name for the location. Maximum 200 characters. */
  label: string
  /** Latitude coordinate. Must be between -90.0 and 90.0. Cannot be zero. */
  lat: number
  /** Longitude coordinate. Must be between -180.0 and 180.0. Cannot be zero. */
  long: number
}
export type SchemaWaContentOptions = {
  /** Answer ID */
  id?: string
  /** Answer Title */
  title?: string
}[]
export type SchemaWaContentFlow = {
  /** The main message text displayed above the buttons. Maximum 1024 characters. */
  message: string
  /** The button to open the flow. */
  button: string
  /** Extra text */
  substitle?: string
  /** Array of pages */
  pages?: {
    /** Page ID, exact allowed characters TBD */
    id: string
    /** Page title */
    title: string
    /** Extra text */
    subtitle?: string
    /** Things in the page. */
    elements?: {
      /** Answer field */
      questionId?: string
      /** Short Text */
      short_text?: {
        /** Question */
        question: string
        /** Help Text */
        help_text?: string
        required?: boolean
        /** Defaults to TEXT. Valid values: TEXT, NUMBER, EMAIL, PASSWORD, PASSCODE, PHONE */
        type?: string
      }
      /** Long Text */
      long_text?: {
        /** Question */
        question: string
        /** Help Text */
        help_text?: string
        required?: boolean
      }
      /** Single Select */
      single_select?: {
        /** Question */
        question: string
        /** Help Text */
        help_text?: string
        required?: boolean
        options?: SchemaWaContentOptions
      }
      /** Multi Select */
      multi_select?: {
        /** Question */
        question: string
        /** Help Text */
        help_text?: string
        required?: boolean
        options?: SchemaWaContentOptions
      }
      /** List */
      list?: {
        /** Question */
        question: string
        /** Help Text */
        help_text?: string
        options?: SchemaWaContentOptions
      }
      /** Date picker */
      date?: {
        /** Question */
        question: string
        /** Earliest date */
        min_date?: string
        /** Latest date (not sure if that's in- or excluding) */
        max_date?: string
        /** Not these dates. */
        unavailable_dates?: string[]
      }
      /** Text Body */
      text_body?: {
        /** Text, can be markdown. */
        text: string
      }
      /** Text Caption */
      text_caption?: {
        /** Text, can be markdown. */
        text: string
      }
      /** Text Heading */
      text_heading?: {
        /** Text, can be markdown. */
        text: string
      }
      /** Text Subheading */
      text_subheading?: {
        /** Text, can be markdown. */
        text: string
      }
      /** Rich Text */
      rich_text?: {
        /** Paragraphs. */
        texts: string[]
      }
      /** File, which is a reference to our storage. */
      media?: {
        /** Filename on our storage. */
        file: string
      }
      /** Footer */
      footer?: {
        footer: string
      }
    }[]
  }[]
}
export type SchemaWaContent = {
  message?: SchemaWaContentMessage
  image?: SchemaWaContentMedia
  audio?: SchemaWaContentMedia
  video?: SchemaWaContentMedia
  document?: SchemaWaContentMedia
  buttons?: SchemaWaContentButtons
  list?: SchemaWaContentList
  location?: SchemaWaContentLocation
  flow?: SchemaWaContentFlow
}
export type SchemaUsed = {
  /** {{contact.id}} */
  contactId?: boolean
  /** {{contact.firstName}} */
  contactFirstName?: boolean
  /** {{contact.lastName}} */
  contactLastName?: boolean
  /** {{contact.fullPhoneNumber}} */
  contactFullPhoneNumber?: boolean
  /** {{contact.language}} */
  contactLanguage?: boolean
  /** {{contact.created}} */
  contactCreated?: boolean
  /** {{groupsize.123}} */
  groupIds?: {
    [key: string]: string
  }
  /** {{customfields.123}} */
  customFieldIds?: {
    [key: string]: string
  }
  /** {{utc.now}} {{utc.today}} {{utc.nowz}} */
  utc?: boolean
}
export type SchemaWatemplate = {
  /** ID */
  id: number
  /** Twilio ID, this changes on re-registration */
  sid: string
  /** Creation time */
  created: string
  /** Confirmed WhatsApp category. (e.g. "UTILITY") */
  category: string
  /** Do we want to register this template with Meta? */
  register: boolean
  /** Waiting for approval. */
  pending: boolean
  /** Did Meta approve this template? */
  approved: boolean
  content: SchemaWaContent
  used?: SchemaUsed
}
export const {
  useCreateOrgAiCampaignMutation,
  useGetAirtimePricingQuery,
  useAuthSignupMutation,
  useAuthSignupEmailMutation,
  useAuthEmailcheckQuery,
  useAuthSigninMutation,
  useAuthTotpMutation,
  useAuthPasswordResetMutation,
  useAuthPasswordResetChangeMutation,
  useSignPathsMutation,
  useGetOrgBalanceQuery,
  useUpdateOrgBalanceMutation,
  useGetOrgBillingQuery,
  useTransferOrgFundsMutation,
  useListOrgRecordingsQuery,
  useDownloadOrgRecordingsMutation,
  useGetOrgRecordingQuery,
  useDownloadOrgRecordingQuery,
  useListCampaignsQuery,
  useCreateCampaignMutation,
  useGetCampaignQuery,
  useUpdateCampaignMutation,
  useDeleteCampaignMutation,
  useSubscribeContactMutation,
  useSubscribeContactsMutation,
  useUnsubscribeContactMutation,
  useUnsubscribeContactsMutation,
  useSetCampaignOpenMutation,
  useSetCampaignArchivedMutation,
  useAbortCampaignMutation,
  useCopyCampaignMutation,
  useReopenContactsMutation,
  useSetCampaignPublishedMutation,
  useGetCampaignSummaryQuery,
  useExportCampaignReportQuery,
  useListCampaignSubscriptionsQuery,
  useGetCampaignSubscriptionQuery,
  useGetOrgAutodeleteQuery,
  useListContactsQuery,
  useCreateContactMutation,
  useGetContactQuery,
  useUpdateContactMutation,
  useDeleteContactMutation,
  useGetOrgCustomfieldsQuery,
  useCreateOrgCustomfieldMutation,
  useUpdateOrgCustomfieldMutation,
  useDeleteOrgCustomfieldMutation,
  useCxRequestMutation,
  useListDatatablesQuery,
  useGetDatatableQuery,
  usePopDatatableQuery,
  useRowsDatatableQuery,
  useRowDatatableQuery,
  usePutrowDatatableMutation,
  useGetOrgDidsQuery,
  useGetOrgDidQuery,
  usePostOrgDidMutation,
  usePostDidRegisterWhatsAppMutation,
  useCreateOrgDidHookMutation,
  useUpdateOrgDidHookMutation,
  useDeleteOrgDidHookMutation,
  useCreateOrgDidCallHookMutation,
  useUpdateOrgDidCallHookMutation,
  useDeleteOrgDidCallHookMutation,
  useCreateOrgDidWaHookMutation,
  useUpdateOrgDidWaHookMutation,
  useDeleteOrgDidWaHookMutation,
  useGetExportsListQuery,
  useGetExportQuery,
  useDeleteExportMutation,
  useGetExportsFileQuery,
  useGetFileListQuery,
  useUploadFileMutation,
  useDownloadFileQuery,
  useUpdateFileMutation,
  useDeleteFileMutation,
  useGetOrgGroupsListQuery,
  useCreateOrgGroupMutation,
  useGetOrgGroupQuery,
  useUpdateOrgGroupMutation,
  useDeleteOrgGroupMutation,
  useAddOrgGroupsContactsMutation,
  useDeleteOrgGroupContactsMutation,
  useInviteCheckQuery,
  useInviteAcceptMutation,
  useInviteSignupAcceptMutation,
  useGetOrgInvitesListQuery,
  useCreateOrgInviteMutation,
  useDeleteOrgInviteMutation,
  useCreateOrgBankTransferPdfMutation,
  useGetOrgInvoiceListQuery,
  useCreateOrganizationMutation,
  useGetOrganizationQuery,
  useUpdateOrganizationMutation,
  useGetOrgPlanQuery,
  useUpdateOrgPlanMutation,
  useCancelOrgPlanMutation,
  useGetOrgPaymentsCreditCardsQuery,
  usePostOrgPaymentsCreditCardsMutation,
  useDeleteOrgPaymentsCreditCardMutation,
  usePostOrgPaymentsCreditCardChargeMutation,
  useGetOrgPhonenumberQuery,
  useGetBlockListQuery,
  useCreateBlockMutation,
  useGetBlockQuery,
  useDeleteBlockMutation,
  useGetOrgPurchaseListQuery,
  useCreateOrgReportMutation,
  useGetOrgSenderIdsQuery,
  useSendOrgSmsContactsMutation,
  useSendSmsContactMutation,
  useSendSmsPhonenumberMutation,
  useSendWhatsAppContactMutation,
  useGetSmsListQuery,
  useGetSmsQuery,
  useGetSnippetListQuery,
  useCreateSnippetMutation,
  useGetSnippetQuery,
  useUpdateSnippetMutation,
  useDeleteSnippetMutation,
  useUpdateSubscriptionsMutation,
  useUpdateSubscriptionMutation,
  useSubsReopenMutation,
  useCreateSpeechPreviewMutation,
  useSendOrgTopupMutation,
  useGetOrgTopupsListQuery,
  useGetOrgTopupsQuery,
  useListOrgQuotasQuery,
  useCreateOrgQuotaMutation,
  useGetOrgQuotaQuery,
  useUpdateOrgQuotaMutation,
  useDeleteOrgQuotaMutation,
  useTranscribeFileMutation,
  useGetUserQuery,
  useSaveUserMutation,
  useUserFeedbackMutation,
  useGetUserTotpQuery,
  useSetUserTotpMutation,
  useDisableUserTotpMutation,
  useGetUserRecoveryCodesQuery,
  useNewUserRecoveryCodesMutation,
  useListUserAuthTokensQuery,
  useCreateUserAuthTokenMutation,
  useGetUserAuthTokenQuery,
  useUpdateUserAuthTokenMutation,
  useDeleteUserAuthTokenMutation,
  useGetOrgUserListQuery,
  useGetOrgUserQuery,
  useUpdateOrgUserMutation,
  useDeleteOrgUserMutation,
  useGetWhatsAppListQuery,
  useGetWhatsAppQuery,
  useExportWhatsAppQuery,
  useGetOrgWaTemplatesListQuery,
  useGetOrgWaTemplatesGetQuery,
  useGetOrgWaTemplatesRefreshMutation,
  useGetOrgWaTemplatesRegisterMutation,
} = injectedRtkApi
